export const Max_PRODUCT_PRICE = 1000000; // 10 Lakh

export const INITIAL_PRODUCT_PRICE = 100000; // 1 Lakh

export const PREMIUM_BRANDS =
  "5,8,9,44,55,57,58,107,110,139,141,181,190,194,195,215,218,221,231,236,237,316,323,334,349,357,368,370,397,418,443,444,446,447,448,475,482,490,495,517,519,526,540,541,567,605,631,633,641,653,656,657,661,666,678,718,725,750,753,767,792,840,850,854,880,896,904,931,933,940,951,958,1007,1012,1054,1058,1088,1096,1098,1125,1131,1154,1172,1179,1213,1235,1259,1347,2363,2389,3967,6205,8159,8499,8957,8993,9048,9055,9087,9093,9098";

export const PREMIUM_BAG_SHOES = "5,8,9,10,76,77,78,79,80,81,36,75";

export const TABLIST = [
  { id: "Что-такое-posh-market", title: "Что такое POSH-MARKET" },
  { id: "Инструкция-для-покупателей", title: "Инструкция для покупателей" },
  { id: "Инструкция-для-продавцов", title: "Инструкция для продавцов" },
  // { id: "Безопасная-сделка", title: "Безопасная сделка" },
  { id: "Доставка-и-возврат", title: "Доставка и возврат" },
  { id: "Проверка-подлинности", title: "Проверка подлинности" },
  { id: "Комиссия", title: "Комиссия" },
  // { id: "Служба-поддержки", title: "Служба поддержки" },
];

export const TRANSACTION_STAGES = [
  {
    id: 1,
    title: "Подтверждение наличия",
    content: "Подтвердите наличие товара",
  },
  {
    id: 2,
    title: "Наличие подтверждено",
    content: "После подтверждения наличия покупатель может оплатить товар",
  },
  {
    id: 3,
    title: "Товар оплачен",
    content:
      "Денежные средства за товар заморожены у покупателя и хранятся в Тинькофф банке до конца сделки",
  },
  {
    id: 4,
    title: "Отправка товара",
    content:
      "После оплаты необходимо из приложения вызывать курьера СДЭК или оформить заявку на передачу товара на ПВЗ",
  },
  {
    id: 5,
    title: "Проверка подлинности",
    content: `Если товар стоит более 20 000 руб, он сначала доставляется в POSH MARKET для прохождения проверки подлинности.`,
  },
  {
    id: 6,
    title: "Доставка до покупателя",
    content:
      "После прохождения проверки подлинности товар доставляется до покупателя. Возврат возможен только в случае, если товар не соответствует описанию",
  },
  {
    id: 7,
    title: "Закрытие сделки",
    content:
      "После подтверждения получения товара покупателем, продавец закрывает сделку и мгновенно получает денежные средства на карту",
  },
];

export const BUYERS_TRANSACTION_STAGES = [
  {
    id: 1,
    title: "Подтверждение наличия",
    content: "Запросите наличие интересующего вас товара",
  },
  {
    id: 2,
    title: "Наличие подтверждено",
    content: "После подтверждения наличия продавцом, вы можете произвести оплату",
  },
  {
    id: 3,
    title: "Товар оплачен",
    content:
      "После оплаты, ваши денежные средства заморожены и хранятся в Тинькофф банке до конца сделки",
  },
  {
    id: 4,
    title: "Отправка товара",
    content:
      "После оплаты, продавец оформляет заявку на доставку и отправляет товар",
  },
  {
    id: 5,
    title: "Проверка подлинности",
    content: `Если товар стоит более 20 000 руб, он сначала доставляется в POSH MARKET для прохождения проверки подлинности. Для товаров с ценой ниже, проверку подлинности можно заказать как доп услугу`,
  },
  {
    id: 6,
    title: "Доставка до покупателя",
    content:
      "После прохождения проверки подлинности, товар доставляется до покупателя. Возврат возможен только в случае, если товар не соответствует описанию",
  },
  {
    id: 7,
    title: "Закрытие сделки",
    content:
      "После получения товара покупатель закрывает сделку со своей стороны",
  },
];

export const SAFE_DEAL_STEP = [
  {
    id: 1,
    title: "Безопасная сделка осуществляется совместно с Тинькофф банком",
  },
  {
    id: 2,
    title: "Денежные средства хранятся в Тинькофф банк до завершения сделки.",
  },
  {
    id: 3,
    title:
      "Продавец получает деньги за сделку после того, как покупатель подтверждает получение товара.",
  },
  {
    id: 4,
    title:
      "Продавец получает деньги за сделку после того, как покупатель подтверждает получение товара.",
  },
];

export const CATEGORY_SUBCATEGORY = [
  {
    categorynames: "Аксессуары",
    main_cat_id: 1,
    category_id: 2,
    sub_categories: [
      {
        sub_categorynames: "Головные уборы",
        size_set_id: 4,
        product_count: 409,
        category_id: 39,
        parent_category_id: 2,
      },
      {
        sub_categorynames: "Очки",
        size_set_id: 4,
        product_count: 1810,
        category_id: 40,
        parent_category_id: 2,
      },
      {
        sub_categorynames: "Шарфы",
        size_set_id: 4,
        product_count: 770,
        category_id: 42,
        parent_category_id: 2,
      },
      {
        sub_categorynames: "Зонты",
        size_set_id: 4,
        product_count: 20,
        category_id: 45,
        parent_category_id: 2,
      },
      {
        sub_categorynames: "Ремни",
        size_set_id: 4,
        product_count: 825,
        category_id: 46,
        parent_category_id: 2,
      },
      {
        sub_categorynames: "Перчатки",
        size_set_id: 4,
        product_count: 73,
        category_id: 48,
        parent_category_id: 2,
      },
      {
        sub_categorynames: "Другое",
        size_set_id: 4,
        product_count: 915,
        category_id: 51,
        parent_category_id: 2,
      },
      {
        sub_categorynames: "Часы",
        size_set_id: 4,
        product_count: 473,
        category_id: 92,
        parent_category_id: 2,
      },
      {
        sub_categorynames: "Украшения",
        size_set_id: 4,
        product_count: 1763,
        category_id: 93,
        parent_category_id: 2,
      },
      {
        sub_categorynames: "Кошельки",
        size_set_id: 4,
        product_count: 821,
        category_id: 102,
        parent_category_id: 2,
      },
    ],
  },
  {
    categorynames: "Обувь",
    main_cat_id: 1,
    category_id: 3,
    sub_categories: [
      {
        sub_categorynames: "Босоножки",
        size_set_id: 3,
        product_count: 4586,
        category_id: 7,
        parent_category_id: 3,
      },
      {
        sub_categorynames: "Балетки",
        size_set_id: 3,
        product_count: 953,
        category_id: 29,
        parent_category_id: 3,
      },
      {
        sub_categorynames: "Ботильоны",
        size_set_id: 3,
        product_count: 2185,
        category_id: 30,
        parent_category_id: 3,
      },
      {
        sub_categorynames: "Ботинки",
        size_set_id: 3,
        product_count: 1491,
        category_id: 31,
        parent_category_id: 3,
      },
      {
        sub_categorynames: "Лоферы",
        size_set_id: 3,
        product_count: 445,
        category_id: 32,
        parent_category_id: 3,
      },
      {
        sub_categorynames: "Мокасины",
        size_set_id: 3,
        product_count: 157,
        category_id: 33,
        parent_category_id: 3,
      },
      {
        sub_categorynames: "Сапоги",
        size_set_id: 3,
        product_count: 2390,
        category_id: 34,
        parent_category_id: 3,
      },
      {
        sub_categorynames: "Кеды и кроссовки",
        size_set_id: 3,
        product_count: 4091,
        category_id: 35,
        parent_category_id: 3,
      },
      {
        sub_categorynames: "Туфли",
        size_set_id: 3,
        product_count: 5941,
        category_id: 36,
        parent_category_id: 3,
      },
      {
        sub_categorynames: "Шлепанцы",
        size_set_id: 3,
        product_count: 647,
        category_id: 37,
        parent_category_id: 3,
      },
      {
        sub_categorynames: "Эспадрильи",
        size_set_id: 3,
        product_count: 295,
        category_id: 38,
        parent_category_id: 3,
      },
      {
        sub_categorynames: "Угги",
        size_set_id: 3,
        product_count: 151,
        category_id: 43,
        parent_category_id: 3,
      },
      {
        sub_categorynames: "Слипоны",
        size_set_id: 3,
        product_count: 403,
        category_id: 44,
        parent_category_id: 3,
      },
    ],
  },
  {
    categorynames: "Одежда",
    main_cat_id: 1,
    category_id: 1,
    sub_categories: [
      {
        sub_categorynames: "Джинсы",
        size_set_id: 2,
        product_count: 2424,
        category_id: 6,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Блузки и рубашки",
        size_set_id: 1,
        product_count: 2152,
        category_id: 11,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Брюки",
        size_set_id: 1,
        product_count: 1502,
        category_id: 12,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Комбинезоны",
        size_set_id: 1,
        product_count: 312,
        category_id: 13,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Костюмы",
        size_set_id: 1,
        product_count: 837,
        category_id: 14,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Кофты и кардиганы",
        size_set_id: 1,
        product_count: 2006,
        category_id: 15,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Куртки",
        size_set_id: 1,
        product_count: 2437,
        category_id: 16,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Леггинсы",
        size_set_id: 1,
        product_count: 115,
        category_id: 17,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Пальто",
        size_set_id: 1,
        product_count: 1648,
        category_id: 18,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Пиджаки и жакеты",
        size_set_id: 1,
        product_count: 1399,
        category_id: 19,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Платья",
        size_set_id: 1,
        product_count: 8526,
        category_id: 20,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Пляжная одежда",
        size_set_id: 1,
        product_count: 90,
        category_id: 21,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Свитеры и свитшоты",
        size_set_id: 1,
        product_count: 1570,
        category_id: 22,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Спортивная одежда",
        size_set_id: 1,
        product_count: 347,
        category_id: 23,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Топы",
        size_set_id: 1,
        product_count: 1242,
        category_id: 24,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Туники",
        size_set_id: 1,
        product_count: 228,
        category_id: 25,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Футболки и поло",
        size_set_id: 1,
        product_count: 1547,
        category_id: 26,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Шорты",
        size_set_id: 1,
        product_count: 460,
        category_id: 27,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Юбки",
        size_set_id: 1,
        product_count: 2296,
        category_id: 28,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Шубы",
        size_set_id: 1,
        product_count: 574,
        category_id: 47,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Жилеты",
        size_set_id: 1,
        product_count: 405,
        category_id: 49,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Плащи",
        size_set_id: 1,
        product_count: 427,
        category_id: 50,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Купальники",
        size_set_id: 1,
        product_count: 535,
        category_id: 52,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Пуховики",
        size_set_id: 1,
        product_count: 670,
        category_id: 91,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Дубленки",
        size_set_id: 1,
        product_count: 200,
        category_id: 99,
        parent_category_id: 1,
      },
      {
        sub_categorynames: "Домашняя одежда",
        size_set_id: 1,
        product_count: 11,
        category_id: 106,
        parent_category_id: 1,
      },
    ],
  },
  {
    categorynames: "Сумки",
    main_cat_id: 1,
    category_id: 4,
    sub_categories: [
      {
        sub_categorynames: "Повседневные сумки",
        size_set_id: 4,
        product_count: 9348,
        category_id: 5,
        parent_category_id: 4,
      },
      {
        sub_categorynames: "Вечерние сумки и клатчи",
        size_set_id: 4,
        product_count: 2281,
        category_id: 8,
        parent_category_id: 4,
      },
      {
        sub_categorynames: "Дорожные сумки",
        size_set_id: 4,
        product_count: 168,
        category_id: 9,
        parent_category_id: 4,
      },
      {
        sub_categorynames: "Рюкзаки",
        size_set_id: 4,
        product_count: 731,
        category_id: 10,
        parent_category_id: 4,
      },
    ],
  },
  {
    categorynames: "Косметика и духи",
    main_cat_id: 1,
    category_id: 103,
    sub_categories: [
      {
        sub_categorynames: "Косметика",
        size_set_id: 4,
        product_count: 417,
        category_id: 104,
        parent_category_id: 103,
      },
      {
        sub_categorynames: "Духи",
        size_set_id: 4,
        product_count: 1035,
        category_id: 105,
        parent_category_id: 103,
      },
    ],
  },
  {
    categorynames: "Аксессуары",
    main_cat_id: 2,
    category_id: 54,
    sub_categories: [
      {
        sub_categorynames: "Визитницы",
        size_set_id: 4,
        product_count: 17,
        category_id: 82,
        parent_category_id: 54,
      },
      {
        sub_categorynames: "Галстуки и бабочки",
        size_set_id: 4,
        product_count: 174,
        category_id: 83,
        parent_category_id: 54,
      },
      {
        sub_categorynames: "Головные уборы",
        size_set_id: 4,
        product_count: 110,
        category_id: 84,
        parent_category_id: 54,
      },
      {
        sub_categorynames: "Кошельки",
        size_set_id: 4,
        product_count: 188,
        category_id: 85,
        parent_category_id: 54,
      },
      {
        sub_categorynames: "Очки",
        size_set_id: 4,
        product_count: 145,
        category_id: 86,
        parent_category_id: 54,
      },
      {
        sub_categorynames: "Перчатки",
        size_set_id: 4,
        product_count: 8,
        category_id: 87,
        parent_category_id: 54,
      },
      {
        sub_categorynames: "Ремни",
        size_set_id: 4,
        product_count: 178,
        category_id: 88,
        parent_category_id: 54,
      },
      {
        sub_categorynames: "Шарфы",
        size_set_id: 4,
        product_count: 48,
        category_id: 89,
        parent_category_id: 54,
      },
      {
        sub_categorynames: "Часы",
        size_set_id: 4,
        product_count: 160,
        category_id: 94,
        parent_category_id: 54,
      },
      {
        sub_categorynames: "Украшения",
        size_set_id: 4,
        product_count: 78,
        category_id: 100,
        parent_category_id: 54,
      },
      {
        sub_categorynames: "Запонки",
        size_set_id: 4,
        product_count: 31,
        category_id: 101,
        parent_category_id: 54,
      },
    ],
  },
  {
    categorynames: "Обувь",
    main_cat_id: 2,
    category_id: 55,
    sub_categories: [
      {
        sub_categorynames: "Ботинки",
        size_set_id: 6,
        product_count: 307,
        category_id: 69,
        parent_category_id: 55,
      },
      {
        sub_categorynames: "Кеды и кроссовки",
        size_set_id: 6,
        product_count: 1264,
        category_id: 70,
        parent_category_id: 55,
      },
      {
        sub_categorynames: "Мокасины",
        size_set_id: 6,
        product_count: 147,
        category_id: 71,
        parent_category_id: 55,
      },
      {
        sub_categorynames: "Лоферы",
        size_set_id: 6,
        product_count: 89,
        category_id: 72,
        parent_category_id: 55,
      },
      {
        sub_categorynames: "Шлепанцы",
        size_set_id: 6,
        product_count: 67,
        category_id: 73,
        parent_category_id: 55,
      },
      {
        sub_categorynames: "Слипоны",
        size_set_id: 6,
        product_count: 49,
        category_id: 74,
        parent_category_id: 55,
      },
      {
        sub_categorynames: "Туфли",
        size_set_id: 6,
        product_count: 198,
        category_id: 75,
        parent_category_id: 55,
      },
    ],
  },
  {
    categorynames: "Одежда",
    main_cat_id: 2,
    category_id: 56,
    sub_categories: [
      {
        sub_categorynames: "Брюки",
        size_set_id: 7,
        product_count: 213,
        category_id: 58,
        parent_category_id: 56,
      },
      {
        sub_categorynames: "Куртки",
        size_set_id: 7,
        product_count: 805,
        category_id: 59,
        parent_category_id: 56,
      },
      {
        sub_categorynames: "Водолазки",
        size_set_id: 7,
        product_count: 41,
        category_id: 60,
        parent_category_id: 56,
      },
      {
        sub_categorynames: "Джемперы и кардиганы",
        size_set_id: 7,
        product_count: 712,
        category_id: 61,
        parent_category_id: 56,
      },
      {
        sub_categorynames: "Джинсы",
        size_set_id: 5,
        product_count: 408,
        category_id: 62,
        parent_category_id: 56,
      },
      {
        sub_categorynames: "Костюмы",
        size_set_id: 7,
        product_count: 124,
        category_id: 63,
        parent_category_id: 56,
      },
      {
        sub_categorynames: "Пиджаки",
        size_set_id: 7,
        product_count: 166,
        category_id: 64,
        parent_category_id: 56,
      },
      {
        sub_categorynames: "Поло и футболки",
        size_set_id: 7,
        product_count: 878,
        category_id: 65,
        parent_category_id: 56,
      },
      {
        sub_categorynames: "Рубашки",
        size_set_id: 7,
        product_count: 428,
        category_id: 66,
        parent_category_id: 56,
      },
      {
        sub_categorynames: "Спортивная одежда",
        size_set_id: 7,
        product_count: 275,
        category_id: 67,
        parent_category_id: 56,
      },
      {
        sub_categorynames: "Шорты",
        size_set_id: 7,
        product_count: 155,
        category_id: 68,
        parent_category_id: 56,
      },
      {
        sub_categorynames: "Пуховики",
        size_set_id: 7,
        product_count: 116,
        category_id: 90,
        parent_category_id: 56,
      },
      {
        sub_categorynames: "Дубленки",
        size_set_id: 7,
        product_count: 35,
        category_id: 95,
        parent_category_id: 56,
      },
      {
        sub_categorynames: "Пальто",
        size_set_id: 7,
        product_count: 127,
        category_id: 97,
        parent_category_id: 56,
      },
      {
        sub_categorynames: "Плащи",
        size_set_id: 7,
        product_count: 40,
        category_id: 98,
        parent_category_id: 56,
      },
      {
        sub_categorynames: "Домашняя одежда",
        size_set_id: 7,
        product_count: 0,
        category_id: 107,
        parent_category_id: 56,
      },
    ],
  },
  {
    categorynames: "Сумки",
    main_cat_id: 2,
    category_id: 57,
    sub_categories: [
      {
        sub_categorynames: "Барсетки",
        size_set_id: 4,
        product_count: 48,
        category_id: 76,
        parent_category_id: 57,
      },
      {
        sub_categorynames: "Дорожные сумки",
        size_set_id: 4,
        product_count: 35,
        category_id: 77,
        parent_category_id: 57,
      },
      {
        sub_categorynames: "Портфели",
        size_set_id: 4,
        product_count: 72,
        category_id: 78,
        parent_category_id: 57,
      },
      {
        sub_categorynames: "Рюкзаки",
        size_set_id: 4,
        product_count: 91,
        category_id: 79,
        parent_category_id: 57,
      },
      {
        sub_categorynames: "Спортивные сумки",
        size_set_id: 4,
        product_count: 15,
        category_id: 80,
        parent_category_id: 57,
      },
      {
        sub_categorynames: "Сумки через плечо",
        size_set_id: 4,
        product_count: 176,
        category_id: 81,
        parent_category_id: 57,
      },
    ],
  },
  {
    categorynames: "kids_accessoriesRuss",
    main_cat_id: 3,
    category_id: 108,
    sub_categories: [
      {
        sub_categorynames: "accR1",
        size_set_id: 4,
        product_count: 1,
        category_id: 111,
        parent_category_id: 108,
      },
      {
        sub_categorynames: "accR2",
        size_set_id: 4,
        product_count: 0,
        category_id: 112,
        parent_category_id: 108,
      },
    ],
  },
  {
    categorynames: "kids_dressR",
    main_cat_id: 3,
    category_id: 109,
    sub_categories: [
      {
        sub_categorynames: "dressR1",
        size_set_id: 8,
        product_count: 1,
        category_id: 113,
        parent_category_id: 109,
      },
      {
        sub_categorynames: "dressR2",
        size_set_id: 8,
        product_count: 0,
        category_id: 114,
        parent_category_id: 109,
      },
    ],
  },
  {
    categorynames: "kids_topRuss",
    main_cat_id: 3,
    category_id: 110,
    sub_categories: [
      {
        sub_categorynames: "topR1",
        size_set_id: 8,
        product_count: 0,
        category_id: 115,
        parent_category_id: 110,
      },
      {
        sub_categorynames: "topR2",
        size_set_id: 8,
        product_count: 0,
        category_id: 116,
        parent_category_id: 110,
      },
    ],
  },
  {
    categorynames: "kids_shoesRuss",
    main_cat_id: 3,
    category_id: 117,
    sub_categories: [
      {
        sub_categorynames: "sandalsR",
        size_set_id: 9,
        product_count: 0,
        category_id: 118,
        parent_category_id: 117,
      },
      {
        sub_categorynames: "bootsR",
        size_set_id: 9,
        product_count: 1,
        category_id: 119,
        parent_category_id: 117,
      },
      {
        sub_categorynames: "flatsR",
        size_set_id: 9,
        product_count: 0,
        category_id: 120,
        parent_category_id: 117,
      },
    ],
  },
  {
    categorynames: "boy_clothesRuss",
    main_cat_id: 4,
    category_id: 121,
    sub_categories: [
      {
        sub_categorynames: "clothesR1",
        size_set_id: 8,
        product_count: 1,
        category_id: 123,
        parent_category_id: 121,
      },
    ],
  },
  {
    categorynames: "boy_shoes",
    main_cat_id: 4,
    category_id: 122,
    sub_categories: [
      {
        sub_categorynames: "shoesR1",
        size_set_id: 9,
        product_count: 0,
        category_id: 124,
        parent_category_id: 122,
      },
    ],
  },
];

export const META_DATA = {
  home: {
    title: 'POSH MARKET: ресейл платформа для покупки и продажи брендовыхвещей',
    description: 'Покупайте и продавайте на POSH MARKET. Объявления от частных продавцов о продаже брендовых вещей со скидками до 90% � Проверка подлинности и безопасная сделка ✅',
    description2: '61TWWiVyXQnB299sgQAMk2UxRwQjPM9H9lq1d1RlUl0'
  },
  women: {
    title: 'Брендовая женская одежда, обувь и сумки от частных продавцов',
    description: 'Женская одежда, обувь, сумки люксовых и премиальных брендов от частных продавцов. Покупайте со скидками до 90%'
  },
  man: {
    title: 'Брендовая мужская одежда, обувь и сумки от частных продавцов',
    description: 'Мужика одежда, обувь, сумки люксовых и премиальных брендов от частных продавцов. Покупайте со скидками до 90%'
  },
  blog: {
    title: 'Мода и тренды в блоге Posh Market',
    description: 'Мода и тренды. Все, что вы хотели знать про новинки и тенденции моды, в блоге Posh Market. Узнавайте про тренды первыми!'
  },
  about: {
    title: 'О нас: Posh Market ресейл платформа для покупки и продажи брендовых вещей',
    description: 'Покупайте и продавайте брендовые вещи на POSH MARKET! Проверка подлинности и безопасная сделка ✅'
  },
  brand: {
    title: 'Люксовые и премиальные бренды со скидками до 90%',
    description: 'Люксовые и премиальные бренды со скидками до 90%. Объявления о продаже от частных продавцов'
  },
  productDetails: {
    title: '',
    description: ''
  }
}

export const BRAND_SEO_TEXT = {
  'KENZO': [
    {
      title: 'Kenzo Одежда для Смелых Трендсеттеров',
      desc: ['Парижский дом моды Kenzo создает одежду с яркой энергией молодости. Созданный в 1970 году Кензо Такада, бренд в настоящее время находится под творческим руководством Фелипе Оливейры Баптисты и черпает вдохновение для своих эклектичных мотивов в различных культурах мира. Обратите внимание на фирменный логотип тигра на футболках, толстовках и свитерах в нашем удобном приложении или на сайте, где представлена разнообразная Kenzo одежда из разных коллекций.   Названный в честь основателя компании, бренд Кензо ворвался на парижский модный рынок в 1964 году с яркой одеждой ручной работы, которая продавалась в бутике под названием «Джунгли Джап». В течение следующих нескольких десятилетий Такада превратил свой маленький лейбл во всемирно известный бренд. После выхода Такада на пенсию в 2011 году, Кэрол Лим и Умберто Леон стали креативными директорами марки, переосмыслив фирменные мотивы модного дома: их коллекции включали в себя толстовки с вариациями тигриного логотипа, платья с рисунком в виде глазного яблока и брюки с иероглифами, а каждая сумка Kenzo производила настоящий фурор. Назначив португальского дизайнера Фелипе Оливейру Баптиста руководить художественным направлением, Кензо привнес динамику в развитие бренда. Руководствуясь своим свежим креативным видением, сочетающим эстетику и функциональность, Баптиста начал новую главу в истории лейбла, уважая при этом его уникальное наследие.']
    },
    {
      title: 'Kenzo Купить Онлайн',
      desc: ['Прежде чем добиться успеха, Кензо Такада утолял свою жажду творчества путем поиска тканей на барахолках и пошива из них экспериментальных вещей. Такое начало творческого пути привело к тому, что смелые контрастные ткани стали основой всех элементов одежды всемирно известного бренда. Kenzo одежда теперь доступна не только в фирменных бутиках, но и в онлайн-магазинах. Чтобы покупка модных вещей стала еще проще, вы можете буквально за несколько кликов загрузить наше приложение и получить доступ к невероятно широкому ассортименту вещей Kenzo.']
    }
  ],
  'PRADA': [
    {
      title: 'Прада Одежда Со Вкусом Престижа',
      desc: ['Основанный в 1913 году в престижном миланском Galleria Vittorio Emanuele II, бренд Prada является одним из самых знаменитых домов моды в мире. Унаследовав компанию по производству кожаных изделий своего дедушки в 1978 году, Миучча превратила ее в культовый итальянский дом моды, которым он и является сегодня. Ее первой работой для бренда была безумно популярная линейка нейлоновых сумок Prada – начинание оказалось настолько успешным, что она решила перейти к дизайну и изготовлению одежды. Этот выбор изменил всю ее жизнь и судьбу бренда, превратив небольшую марку в империю мощных модных сил, а саму Миуччу  – в настоящего фэшн-лидера. В нашем приложении, в котором представлена Прада одежда, вы найдете роскошные платья из парчи, утилитарную верхнюю одежду и причудливые культовые аксессуары Prada.',
        'Основанный в 1913 году в престижном миланском Galleria Vittorio Emanuele II, бренд Prada является одним из самых знаменитых домов моды в мире. Унаследовав компанию по производству кожаных изделий своего дедушки в 1978 году, Миучча превратила ее в культовый итальянский дом моды, которым он и является сегодня. Ее первой работой для бренда была безумно популярная линейка нейлоновых сумок Prada – начинание оказалось настолько успешным, что она решила перейти к дизайну и изготовлению одежды. Этот выбор изменил всю ее жизнь и судьбу бренда, превратив небольшую марку в империю мощных модных сил, а саму Миуччу  – в настоящего фэшн-лидера. В нашем приложении, в котором представлена Прада одежда, вы найдете роскошные платья из парчи, утилитарную верхнюю одежду и причудливые культовые аксессуары Prada.'
      ]
    },
    {
      title: 'Купить Prada Онлайн',
      desc: ['За годы своего существования бренд Prada стал одним из самых известных домов моды в мире, который уделяет особое внимание  мастерству, продвинутым технологиям и инновационным материалам. Являясь синонимом роскошного образа жизни, Prada продолжает воплощать свое видение в новых коллекциях.']
    }
  ],
  'ALAIA': [
    {
      title: 'Alaia Paris - Бренд Замысловатой Обуви и Культовых Аксессуаров',
      desc: [
        'Аззедин Алайа, основатель Alaia бренд, хорошо разбирался в женской одежде, благодаря образованию в области скульптуры в Школе изящных искусств. Французский дизайнер восточного происхождения был известный своими силуэтами обтекаемой формы, которые определили эстетику моды Парижа 80-х. Сейчас Alaia Paris бренд также известен своей сложной обувью, роскошными сумками и аксессуарами, изготовленными по особой технологии. Обратите внимание на вязаные трикотажные платья и короткие платья нестандартного кроя в коллекциях Alaia Paris',
        'Основанная великим Аззедином Алайей в 1981 году и теперь возглавляемая коллективом дизайнеров, которые понимают и чувствуют особенности мастерства кутюрье, студия Алайя воодушевляет трендсеттеров со всего мира. Alaia бренд известен своими скульптурными силуэтами и безупречным дизайнерским мастерством. Многие в мире моды помнят этот бренд, благодаря известной цитате из фильма Clueless: “Ты не понимаешь. Это же Алайя!”',
        'Готовая одежда, обувь и аксессуары из коллекций Alaia Paris объединяют в себе грацию и уравновешенность, мягкость и утонченную легкость с прозрачностью и элегантностью. Плавные и воздушные платья идеально сочетаются с аккуратными геометричными костюмами, трикотажными и джинсовыми вещами.'
      ]
    },
    {
      title: 'Инновационный Подход от Alaia Бренд',
      desc: [
        'Известный благодаря инновационному подходу к дизайну одежды, уроженец Туниса Аззедин Алайя был прежде всего “строителем” в мире моды, а не просто модельером. Всемирно известное черное платье Алайи стало основным предметом гардероба многих модниц, в то время как его замысловатая обувь и культовые аксессуары с лазерной отделкой опередили свое время. Выбирайте и покупайте экстравагантную одежду Alaia бренд и обувь лейбла в нашем интернет-бутике!',
        '“Моя навязчивая идея - сделать женщин красивыми. Когда вы создаете их с этой мыслью, вещи не могут выходить из моды,” - говорил Алайа. С момента своего основания парижский дом Alaia завоевал репутацию благодаря своей оригинальности и уникальному качеству дизайна. Традиция постоянного совершенствования и страсть к исключительности стиля продолжает доминировать во всем, что выпускает Alaia бренд.',
        'Создав свою первую коллекцию готовой одежды, лейбл стал популярен в модных кругах, особенно благодаря стильным платьям Alaia Paris. Сегодня линия бренда также включает трикотажные изделия, безупречно изготовленную обувь и прекрасные кожаные фирменные ремни и сумки класса люкс. Не в последнюю очередь Alaia Paris - это лейбл элегантных аксессуаров, таких как сумка Мина. Мина - классическая большая сумка, легкая и светлая, словно облако. Эти сумки легко узнаваемы благодаря своему четкому дизайну и кожаной отделке.',
        'Широкий ассортимент сумок и одежды Alaia Paris также представлен в нашем онлайн бутике!'
      ]
    }
  ],
  'LOUIS VUITTON': [
    {
      title: 'Louis Vuitton Russia и Легенда По Всему Миру',
      desc: ['С момента создания модного бренда Louis Vuitton вдохновлялись желанием исследовать новые горизонты. Louis Vuitton - один из самых популярных брендов в мире и в каждой стране существуют ответвления и бутики, готовые предоставить трендсеттером доступ к моделям этой легендарной марки, такие как Louis Vuitton Russia. Французский дом моды, основанный в 1854 году, гордится своей знаменитой монограммой LV на большинстве моделей как отличительным знаком качества.  Идеальный выбор для роскошных мужчин и гламурных женщин - сумки и кошельки Louis Vuitton. Они олицетворяют собой легкую парижскую модную суету и шумиху. Каждый из них по-прежнему изготавливается вручную, и входит в подборки самых стильных аксессуаров от сезона к сезону. Сумки Louis Vuitton, в том числе клатчи, кошельки, сумки, портфели, чемоданы и красочные городские модели - последнее слово в мире модных форм и функциональности. Шестнадцатилетний Луи Виттон переехал в Париж с мечтой создать культовую коллекцию дорожных сумок и чемоданов, которая изменит стиль путешествий людей по всему миру. С 1800-х годов марка расширилась, чтобы создать одни из самых знаковых аксессуаров в мире. Делайте покупки в Louis Vuitton Russia или буквально за несколько кликов в нашем удобном приложении - и получите доступ к самым трендовым сумочкам и кошелькам Louis Vuitton.']
    },
    {
      title: 'Чемоданы, Сумки и Кошельки Louis Vuitton',
      desc: ['Louis Vuitton - идеальное воплощение французских инноваций в производстве аксессуаров с легендарной монограммой на них. Это один из самых известных брендов класса люкс в мире и парижский дом моды уже более 160 летней историей изготовления высококлассных сумок, портфелей и кошельков, а также одеждой, обувью и другими аксессуарами. Не в последнюю очередь благодаря поклонникам среди селебрити, таких как Мадонна, Дженнифер Лопес, Анджелина Джоли и Скарлетт Йоханссон, Louis Vuitton является одним из всемирно известных брендов, который создает амбициозные и часто отмеченные наградами коллекции, полные вдохновения. В настоящее время бренд входит в группу LVMH во главе с Николасом Гескьером. Louis Vuitton, чья история и репутация были построены вокруг темы комфортных и стильных путешествий, в современном мире предлагает инновационные модели каждый сезон, но великая классика продолжает привлекать любителей моды во всем мире, в том числе Louis Vuitton Russia.']
    }
  ],
  'GUCCI': [
    {
      title: 'Культовая Одежда и Обувь Gucci – Купить Уже Сегодня',
      desc: ['Почувствуйте романтичный и эклектичный и дух свободы от Gucci! Компания была основана в 1921 году, когда Гуччио Гуччи открыл компанию по производству кожгалантереи и небольшой магазин сумок и чемоданов в своей родной Флоренции. Сегодня он входит в состав модного конгломерата Kering, который контролируется французским бизнесменом Франсуа Пино. Итальянский бренд, выпускающий одежду, аксессуары и обувь Gucci радикально изменился с приходом нового креативного директора Алессандро Микеле – именно он заново соединил традиционную эстетику с причудливыми богемными мотивами.']
    },
    {
      title: 'Одежда и Обувь Gucci – Выбор Смелых',
      desc: ['Купить Gucci в наше время означает открыть для себя непревзойденное итальянское мастерство в каждом образе, сочетающееся с яркими цветами, творческими узорами и элегантными изгибами. В коллекциях, основу которых составляют одежда, сумки и обувь Gucci, представлены самые востребованные элементы – от лоферов Horsebit и сумок Dionysus до изысканных платьев. Изделия из кожи остаются крупнейшим сегментом в продажах культового бренда, на которые приходится 57% общей выручки, ведь сумки Гуччи давно стали символом шика и смелых экспериментов. Сезон за сезоном поклонники Gucci ожидают новых моделей ультрамодных сумок и аксессуаров.']
    }
  ],
  'ALEXANDER MCQUEEN': [
    {
      title: 'Бренд Alexander McQueen Москва и По Всему Миру',
      desc: [
        'Александр Маккуин начинал свою карьеру в качестве ученика Savile Row и театрального костюмера. Необыкновенный стиль этой марки одежды, обуви и аксессуаров определяется эмоциональной силой, бесконечной энергией, а также глубоким уважением к традициям декоративно-прикладного искусства. С 2010 года модный дом возглавляет Сара Бертон, которая привнесла в коллекции легкость и женственность.',
        'Вещи британского бренда Alexander McQueen купить для повседневной жизни - не самая очевидная идея, потому что эта марка обладает особым революционным духом и не каждая модница решится прийти в них в офис или пройтись по улице. Бренд Alexander McQueen - для смелых! Сегодня руководство бренда воплощается в жизнь бывшим арт-директором Сарой Бертон, которая придерживается привычных модных направлений лейбла, но в то же время дополняет их с помощью женственных элементов одежды, кожаных вещей, асимметричных пальто и блузок. Под современным креативным руководством бренд использует контрастные элементы для создания ультрамодных дизайнов. Кроме того, если вы решитесь Alexander McQueen купить определенную вещь для своего гардероба, помните, что бренд известен своей агрессивной сексуальностью.',
        'Александр Маккуин, бренд, известный во всем мире своей современной, но в то же время романтической эстетикой. Осознав, что пора что-то из коллекций Alexander McQueen купить для своего гардероба, вы в полной мере ощутите, что вещи этого бренда сочетают в себе невероятную энергию и революционный дух. Эти же черты присущи коллекциям Alexander McQueen Москва.'
      ]
    },
    {
      title: 'Почему Вещи Alexander McQueen Купить - Хорошая Идея?',
      desc: [
        'Сочетая хрупкость и эксцентричность, марка Александр Маккуин предлагает своим почитателям идеальный британский пошив в сочетании с мастерством безупречной отделки. Благодаря уникальной эстетике, которая балансирует на грани между готикой и женственностью, марка Alexander McQueen идеально подходит для покупки яркой вечерней одежды, а также роскошной верхней одежды и аксессуаров.',
        'В начале своей карьеры Александр приобрел репутацию самого эксцентричного британского дизайнера для плохих парней. Однако в мае 2010 года Сара Бертон, которая работала вместе с Маккуином в течение 14 лет, возглавила бренд и год спустя ее талант проявился в полной мере в великолепном кружевном свадебном платье, которое Кейт Миддлтон надела на свадьбу с принцем Уильямом. Сегодня бренд делает акцент на носибельности одежды, обуви и аксессуаров и имеет большие планы по продвижению в реальные повседневные гардеробы it-girls со всего мира. В современных реалиях для любой уважающей себя фешнисты Alexander McQueen купить для своей коллекции - это прекрасная идея, тем более, что теперь это можно сделать буквально за несколько кликов в нашем онлайн бутике!'
      ]
    }
  ],
  'ALEXANDER TEREKHOV': [
    {
      title: 'Alexander Terekhov – История Бренда',
      desc: ['Молодой, но при этом широкоизвестный, дизайнер Александр Терехов с каждым днем получает все большую славу и признание во всем мире. В детстве он придумывал одежду для кукол, позже - для мамы и сестер создавал первые Александр Терехов платья. Еще первая его студенческая коллекция одежды стала успешным началом карьеры талантливого модельера, а в 2004 у него появился собственный бренд, который шьет женскую одежду и аксессуары - Alexander Terekhov. С тех пор дизайнер постоянно участвует в Нью-Йоркской недели моды. В 2007 он открыл именной бутик в Москве, но все-таки самым удобным способом для модниц со всего мира приобрести вещь от любимого кутюрье остается Alexander Terekhov Online Shop или онлайн магазин бренда.']
    },
    {
      title: 'Александр Терехов Платья, Сумки и Детская Одежда',
      desc: ['Один из самых известных российских дизайнеров Александр Терехов с каждым сезоном получает все большую славу и признание во всем мире. В детстве он придумывал одежду для кукол, позже – для мамы и сестер: именно так и появились первые платья Alexander Terekhov. Его дебютная студенческая коллекция одежды дала старт успешной карьере, а в 2004 у него появился собственный бренд женской одежды и аксессуаров. В 2007 году Терехов открыл именной бутик в Москве, но все-таки самым удобным способом приобрести вещь от российского дизайнера остается Alexander Terekhov online shop – онлайн-магазин бренда.    Платья Alexander Terekhov – центральный предмет каждой коллекции. В 2012 в Alexander Terekhov online shop можно было купить вещи в стиле 50-х, характерными чертами которой были А-силуэты, рябиновый принт, кружево и полупрозрачные ткани. Платья Alexander Terekhov из капсульных коллекций также весьма интересны – в том же 2012 году он выпустил вечерние наряды, приуроченные к выходу фильма «Оз: великий и ужасный» от Disney. В 2014 году под брендом Alexander Terekhov вышла первая коллекция детской одежды в семейном стиле, в которую вошли романтические платья, верхняя одежда свободного кроя и джинсовые брюки с отворотами.']
    },
    {
      title: 'Где Купить Платья Alexander Terekhov?',
      desc: ['Чтобы купить платья Alexander Terekhovили любые другие понравившиеся модели, не обязательно идти в именной бутик в Москве или посещать Неделю моды в Нью-Йорке. Первый вариант – Alexander Terekhov online shop, а второй – выбрать стильную одежду и обувь прямо на этой странице. Несмотря на то, что коллекции одежды от Терехова представлены на мировых подиумах и продаются в элитных бутиках, цены на его коллекции вполне разумны, поэтому романтичные платья Alexander Terekhov может себе позволить любая современная модница.']
    }
  ],
  'BALENCIAGA': [
    {
      title: 'Balenciaga Paris - История Бренда',
      desc: [
        'Когда Демна Гвасалия занял пост художественного руководителя Balenciaga в 2015 году, он привнес свое чувство юмора и инновационный подход к дизайну в стиль модного дома Balenciaga Paris. Именно в это время мечтой многих fashionistas становится вещи и аксессуары Баленсиага купить в Москве. Например, яркие полосатые сумки Bazar или незабываемые Pantshoes. Парижский дом Баленсиага - это имя, которое знают как звезды уличного стиля, так и редакторы модных журналов.',
        'Модный дом изначально выпускал женскую одежду с классическими приталенными силуэтами и пышными юбками. Сегодня под руководством креативного директора дизайнеры марки выбирают также сложные формы и оригинальные материалы. В женской коллекции Balenciaga представлены пальто и объемные худи, кружевные блузки и мягкий трикотаж, ботфорты и массивные кроссовки. Одежда Balenciaga Paris на сегодняшний день имеет сложные узоры и растительные орнаменты.'
      ]
    },
    {
      title: 'Баленсиага Купить в Москве и По Всему Миру',
      desc: [
        'В 1937 году Кристобаль Баленсиага открыл свой первый салон моды в Париже. Испанский дизайнер использовал инновационные материалы и раздвинул границы привычного в моде, благодаря тому, что отдавал предпочтение современными силуэтами. Можно сказать, что Баленсиага в свое время революционизировал индустрию моды. С тех пор у этого культового дома было много руководителей и вдохновителей, но сегодня его возглавляет грузинский дизайнер Демна Гвасалия, и именно он сделал Balenciaga Paris одним из самых современных модных брендов Парижа. Скульптурные формы, выполненные из нестандартных тканей и напоминающие оригинальные силуэты кутюр, остаются главной чертой бренда. А аксессуары и обувь лейбла становятся культовыми в каждом новом сезоне. Например, все помнят нашумевшие кроссовки Triple S и огромные сумки Shopper.',
        'Французский дом моды Balenciaga Paris постоянно пересматривает современные тенденции и изменяет саму суть моды кутюр. С каждым новым художественным руководителем приходит современный взгляд на силуэт, материал и характер коллекции, но общее видение Balenciaga остается чрезвычайно элегантным. С современным составом художественных руководителей, среди которых числились Николас Гескьер, Александр Ван и сам Демна Гвасалия, Баленсиага продолжает балансировать на грани авангардной эстетики. Balenciaga Paris - это один из брендов, которые постоянно заставляют нас переоценивать то, что мы считаем привлекательным и модным. Вещи и обувь Баленсиага купить в Москве теперь очень просто и удобно - на этой странице нашего онлайн бутика вы можете выбрать любые понравившиеся модели и приобрести их буквально за пару кликов!'
      ]
    }
  ],
  'BALMAIN': [
    {
      title: 'Balmain – Женская Обувь и Одежда в Уникальном Стиле',
      desc: ['Неповторимая смесь структурированных форм и строгого гламура от Balmain сделала французский дом знаменитым среди знатоков моды. Под руководством креативного директора Оливье Рустинга, коллекции мужской и женской одежды дома разрушают стандарты сезон за сезоном. Отличительными чертами бренда всегда были стиль милитари, бархат и замша, имитация униформы байкеров. Нестандартная женская обувь Balmain наравне с фирменными пиджаками стала символом бренда – так же как и платье Бальман с высокими плечами.']
    },
    {
      title: 'Платье Бальман – Мечта Каждой Модницы!',
      desc: ['Под влиянием изменений в современном обществе креативный директор Balmain Оливье Рустен внес свои коррективы в эстетику бренда, оставаясь при этом верным замыслу и новаторскому духу его основателя. Так может, пришло время и вам присоединиться к армии поклонников Balmain? Тем более что теперь это сделать совсем несложно, ведь женская обувь Balmain и то самое идеальное платье Бальман уже ждут вас в нашем онлайн-бутике!']
    }
  ],
  'BOGNER': [
    {
      title: 'Бренд Bogner – История Создания',
      desc: ['Бывший чемпион лыжного спорта  Вилли Богнер вдохновился на запуск линии спортивной одежды, когда его жена Мария заметила, что женщинам нечего надевать во время катания на лыжах. Позже под маркой Bogner были созданы культовые брюки, которые носили такие звезды, как Мэрилин Монро и Элизабет Тейлор, а с 1936 года бренд Bogner экипировал олимпийскую сборную Германии. Этот семейный лейбл, возглавляемый сыном Вилли Богнера, мастерски создает верхнюю одежду, трикотаж и аксессуары с дизайнерским подходом. Именно опыт бренда в лыжном спорте оказывает сильное влияние на каждую коллекцию и гарантирует, что моде всегда будет соответствовать функциональность. Представляя коллекции для мужчин, женщин и детей, Bogner предлагает роскошный выбор лыжной одежды - от пуховиков до меховых ботинок. Обувь Bogner идеально подходит как для катания на лыжах, так и для прогулок в зимнее время всей семьей. Со временем бренд Bogner приобрел значительный опыт в модной индустрии и поставил свое имя на первое место в списке лучшего горнолыжного снаряжения. Марка, основанная профессиональным спортсменом Вилли Богнером-старшим в качестве фирмы по импорту спортивной экипировки, до сих пор занимает значительное место в мире моды. Несколько десятков лет назад бренд Bogner начал свое путешествие в фэшн-индустрию под девизом «Присоединяйся к племени», а сегодня одежда и обувь Bogner – это высокая мода для гор и шикарная теплая уличная одежда для города, которую вы можете быстро и удобно купить в нашем онлайн бутике.']
    }
  ],
  'BOTTEGA VENETA': [
    {
      title: 'Бренд Bottega Veneta – в Москве и Во Всем Мире',
      desc: ['Бренд Bottega Veneta является символом безупречного итальянского мастерства и утонченной роскоши с момента его основания в 1966 году. Креативный директор Даниэль Ли тесно сотрудничает с кутюрье других известных брендов, чтобы сохранить в коллекциях определенные культурные коды, и при этом придерживается своей собственной точки зрения на стиль, создавая шикарные сумки, обувь и одежду. Кожаные изделия ручной работы изготовлены с использованием культовой техники intrecciato. Обувь Bottega Veneta - это яркий пример философии бренда, которая предпочитает конструкцию, а не бросающиеся в глаза логотипы.']
    },
    {
      title: 'Одежда и обувь Bottega Veneta – Вне Времени',
      desc: ['Бренд Bottega Veneta установил новый стандарт роскоши с момента своего рождения в Виченце, итальянском регионе Венето. Вещи Bottega Veneta созданы так, чтобы стать частью жизни своих владельцев и проникнуться их эмоциями. Компания гордится осмотрительностью и искусным итальянским мастерством, предлагая непревзойденный уровень качества и изысканности.']
    },
    {
      title: 'Купить Bottega Veneta в Москве',
      desc: ['Несмотря на то, что наследие играет важную роль в стратегии Bottega Veneta, последние творческие разработки Дэниела Ли являются достаточно экспериментальными и подтверждают культовый статус бренда, снискав ему признание в 21 веке. Купить вечную классику от Bottega Veneta в Москве вы можете уже сегодня в нашем онлайн-бутике!']
    }
  ],
  'BURBERRY': [
    {
      title: 'Легендарная Одежда, Ароматы и Сумки Burberry',
      desc: ['В основе философии Burberry лежит сочетание векового наследия и инноваций. Отправной точкой новых коллекций, определяющих модные тенденции, является легендарный тренч: в 1879 году Томас Барберри изобрел габардин, водонепроницаемую и воздухопроницаемую ткань, которая используется в культовых плащах бренда по сей день. Открыв свой первый магазин в Бейзингстоке в 1856 году, Томас Барберри поставлял свои непромокаемые габардиновые пальто офицерам Первой мировой войны. В 2009 году модный дом возглавил Кристофер Бэйли, перенеся показы с подиумов Милана в Лондон и сделав бренд популярным среди знаменитостей. Бэйли покинул Burberry в 2018 году, когда креативным директором бренда стал Рикардо Тиши, который совместно с Питером Сэвиллом выпустил новый логотип и монограмму. На сегодняшний день бренд продолжает выпускать свои классические модели, а вдобавок к ним –  современные сумки Burberry и стильные аксессуары.']
    },
    {
      title: 'Купить Сумки Burberry в Онлайн-Бутике',
      desc: ['Бренд Burberry ассоциируется с высочайшим качеством и неподвластным времени дизайном: знаменитые мотивы часто копируются и имитируются по всему миру, однако ни одна марка не может сравниться в качестве с этим апологетом британской моды. Ароматы Burberry соответствуют многим характеристикам их коллекций одежды – они классические, долговечные и элегантные. Купить легендарные вещи и сумки Burberry вы можете уже сегодня, сделав пару кликов на этой странице!']
    }
  ],
  'CASADEI': [
    {
      title: 'Одежда и Обувь Casadei Официальный Сайт',
      desc: ['Casadei, роскошная марка женской обуви, основанная Quinto и Flora Casadei, мастерски изготавливает Casadei обувь в Италии. Дизайны этого бренда отличаются изысканным стилем, высококачественными материалами, соблазнительными формами и сложными деталями для современных женщин с особенным вкусом. Основанная в 1958 году, Casadei начиналась как небольшая мастерская по изготовлению сандалий для туристов на Французской Ривьере. С тех пор семейный бизнес продолжал создавать красивую обувь для уникальных и уверенных женщин и мужчин. Обладая более чем 50-летним опытом в обувном бизнесе, семья Casadei сама изменила историю итальянской обуви. Произведенная недалеко от Римини в Италии, каждая пара обуви выполнена с использованием эксклюзивных материалов и ручной отделкой. Casadei бренд никогда не забывает свои исторические корни. Он является твердым сторонником истинности и продолжает поставлять самую лучшую итальянскую обувь по всему миру.']
    },
    {
      title: 'Casadei Обувь и Аксессуары в Лучших Итальянских Традициях',
      desc: ['Casadei в наше время - это марка элитной обуви. В модельном ряду бренда туфли, ботинки, сандалии, балетки, кроссовки и многое другое из разных коллекций. Эта роскошная обувная марка производит дизайнерскую обувь мечты, наполненную утонченной женственностью.Стандартные нюдовые или черные туфли-лодочки - редкость для Casadei обувь. Модели с необычными каблуками, лоферы из редких видов кожи, эспадрильи ярких оттенков для этой марки - вот, что отличает эту марку в наше время. Особое внимание дизайнеры уделяют туфлям с тонким и изящным силуэтом. Даже ботильоны, ботинки и кроссовки выглядят женственными и эротичными, поэтому их выбирают для мероприятий и повседневной носки популярные мировые звёзды. Хотите тоже почувствовать себя звездой? У вас есть шанс сделать это буквально за несколько кликов, купив Casadei обувь и одежду в нашем онлайн-бутике.']
    }
  ],
  'CHANEL': [
    {
      title: 'Легенда Современности – Chanel в Москве и во Всем Мире',
      desc: ['В наше время купить сумку Chanel - дело чести для настоящей фэшиониста,  а очарование аромата Шанель № 5 никогда не развеется, несмотря на то, что он существует уже более 100 лет. Преемники Габриель придают современное значение традициям – это можно заметить и в бутиках Chanel в Москве. «Мода приходит и уходит, но стиль длится вечно» – слова, произнесенные Коко Шанель, идеально описали неподвластный времени парижский модный дом. Бренд ориентирован на свободных, независимых и элегантных женщин, а каждая коллекция становилась феноменально успешной с первого дня выхода.']
    },
    {
      title: 'Купить Сумку Chanel Уже Сегодня',
      desc: ['Chanel продолжает устанавливать новые стандарты роскоши: элегантный, шикарный и утонченный – три слова, которые полностью описывают легендарный дом моды. Помимо одежды и самых продаваемых парфюмов, бренд обязан идеальной репутацией своим великолепным кожаным изделиям. Будь то дамские сумки, клатчи или дорожные сумки, изделия марки Chanel гарантированно станут по-настоящему важной частью вашего гардероба. С широким выбором сумок Chanel в нашем онлайн бутике вы наверняка, сможете подобрать себе прекрасный новый и при этом классический аксессуар: предлагаем вам купить сумку Chanel и сделать свой образ по-настоящему стильным!']
    }
  ],
  'CHLOE': [
    {
      title: 'Стильная Одежда и Сумки Chloe',
      desc: ['Эксклюзивные вещи и аксессуары Chloe передают дух современной моды, который Наташа Рамсей-Леви как новый руководитель привнесла в этот известный французский модный дом. Девушки, которые предпочитают одежду и сумки Chloe, можно охарактеризовать тремя словами – шикарные, полные уверенности в себе и при этом беззаботные.  Откройте для себя яркие костюмы, блузки в западном стиле или, например, свежие вариации на тему суперстильной сумки Tess. Чтобы купить Хлое, вам не нужно искать вещи в бутиках или лететь во Францию – сделать это можно за несколько кликов в нашем онлайн бутике или просто загрузив приложение на свой телефон. Выбирайте, какие сумки Chloe подходят вам больше всего: Марси – для повседневной носки, Фэй – для выхода в свет, ну а Тесс – это настоящее модное заявление!']
    },
    {
      title: 'Почему купить Хлое – Хорошая Идея?',
      desc: ['Основанный египетско-французским дизайнером Габи Агион в 1952 году бренд отвергает суровую суть моды, выпуская богемные, чувственные вещи, сделанные из тканей премиум-класса. Купить Хлое означает вдохновиться ​​мягкой женственностью вещей, пропитанных духом современного города: ведь утонченный стиль Chloe выбирали такие известные модницы, как Джеки Кеннеди, Бриджит Бардо, Мария Каллас и Грейс Келли. Для них купить Хлое стало хорошей традицией и именно они сделали этот бренд одним из самых известных в мире. Даже сегодня сильная сторона Chloé заключается в детальном подходе и внимании к созданию каждого элемента и аксессуара, включая пуговицы и украшения. Свобода, легкость, женственность и романтическая природа творений Хлое видна и в современных коллекциях модного дома, что легко заметить в каждой вещи модного дома.']
    }
  ],
  'DIOR': [
    {
      title: 'Одежда, Обувь и Аксессуары Диор Купить Онлайн',
      desc: ['С самого первого своего показа, который состоялся  12 февраля 1947 года, модный дом Диор отстаивает свое видение в элегантных, структурированных и бесконечно женственных коллекциях.  Когда Кристиан Диор открыл свой дом моды в октябре 1946 года, ему был 41 год и он уже накопил богатый опыт работы в модной индустрии. К тому времени он успел открыть художественную галерею в Париже, а затем учился на дизайнера одежды.']
    },
    {
      title: 'Кристиан Диор – Знаковое Имя в Мире Моды',
      desc: ['В послевоенные годы, полные лишения, ограничений и нормирования, у Диора была только одна навязчивая идея. Он хотел дать женщинам заново открыть для себя радость, элегантность и красоту. Всего за десять лет, с 1947 по 1957 год, Christian Dior произвел революцию в понятиях элегантности и женственности, создав элегантные коллекции мечты каждой женщины. Человек, который намеревался стать архитектором, предложил женщинам свое видение красоты и его имя в итоге стало синонимом французской роскоши во всем мире. Со времени своего первого показа Кристиан Диор создавал детально структурированные и интеллектуально продуманные коллекции. Кристиан Диор смог построить концепцию бренда и создать модное наследие, которое поддерживают и переосмысливают новые художественные руководители модного дома, чтобы сохранить это вневременное и неподражаемое видение моды и стиля.']
    },
    {
      title: 'Одежда, Обувь или Сумка Кристиан Диор Купить Уже Сегодня',
      desc: ['Сердце модного дома Диор все еще находится в 8-м округе Парижа, на 30 авеню Монтень, где и началась история бренда. Даже интерьер дома моды Диор идеально отражает дух дизайнера - лепные украшения на стенах, серые тона, изящные стулья, яркие букеты, разбросанные здесь и там, и неоклассическая мебель в стиле Людовика XVI.  Это место, где современность смешивается с историей, было прекрасным фоном для его первых коллекций. Необыкновенный стиль Диор стремятся в наше время представить в каждом уважающем себя бутике по всему миру. Конечно же, эта одежда и аксессуары вне времени представлены и в нашем онлайн бутике, а также в приложении, где вы можете легко и быстро купить любые вещи Диор.']
    },
  ],
  'DOLCE & GABBANA': [
    {
      title: 'Обувь и Одежда Dolce Gabbana – Итальянский Гламур',
      desc: ['Никто не делает вещей роскошнее, чем всемирно известный бренд Dolce & Gabbana. Знаменитый дизайнерский дуэт воплощает в жизнь всю силу итальянского гламура, создавая вещи в концепции «купи сейчас и люби вечно» на протяжении нескольких десятилетий. Игривые принты, элегантная отделка и неповторимые украшения являются характерной особенностью, которая отличает вещи, аксессуары и обувь Dolce Gabbana сезон за сезоном. Dolce & Gabbana был основана в 1985 году в Милане Доменико Дольче и Стефано Габбана. С тех пор их бренд стал одним из самых знаковых в мире, включив в свой ассортимент все -– от мужской одежды до аксессуаров и ароматов.  Неоднозначные принты, изысканные кружева и сицилийские мотивы стали отличительными знаками одного из самых любимых домов моды в мире. А тематические и даже немного насмешливые коллекции бренда выходят за пределы стандартных модных тенденций.']
    },
    {
      title: 'Dolce Gabbana Купить Уже Сегодня',
      desc: ['Обратите внимание на романтичные платья Dolce & Gabbana, а также не забудьте о сумках бренда: выбирайте, что из коллекций бренда Dolce Gabbana купить уже сегодня в нашем онлайн бутике или с помощью удобного приложения Posh Market!']
    }
  ],
  'ERMANNO SCERVINO': [
    {
      title: 'Бунтарские Вещи Ermanno Scervino Купить Онлайн',
      desc: ['Бренд Ermanno Scervino стал синонимом настоящего итальянского качества и неповторимого стиля, обожаемого во всем мире. Страсть к моде и стилю подпитывает креативные поиски бренда и является двигателем его модной стратегии. Купить Ermanno Scervino – значит получить неповторимое сочетание вечных модных ценностей, традиционного качественного пошива и инноваций. Роскошь, современные разработки и никаких предубеждений – в этих трех слагаемых заключается рецепт успеха бренда Ermanno Scervino.']
    },
    {
      title: 'Ermanno Scervino Москва – Итальянское Качество',
      desc: ['Сегодня бренд Scervino предлагает женскую и мужскую одежду, коллекции для пляжа и гламурные стильные образы. Эрманно Шервино – марка для современных стильных мужчин и женщин большого города, которые хотят выглядеть роскошно и при этом вносить в свои образы нотку бунтарства. Благодаря неповторимой индивидуальности и невероятно высокому качеству одежды, бренд продолжает завоевывать себе место под солнцем в модной индустрии. Купить Ermanno Scervino вы можете прямо сейчас, просмотрев коллекцию нашего онлайн-бутика на сайте или в приложении . Широкий ассортимент нашего бутика Ermanno Scervino Москва включает в себя женскую одежду, обувь, аксессуары, сумки и украшения Ermanno Scervino.']
    }
  ],
  'ESCADA': [
    {
      title: 'Escada Одежда – Ультрасовременный Гламур',
      desc: ['Escada крепко ассоциируется со спортивной элегантностью и утонченной модной одеждой еще с 1978 года, когда бывшая шведская модель Маргарета и её супруг Вольфганг Лей выпустили свою первую коллекцию одежды с необычным сочетанием цветов. Сегодня коллекции Escada, в основе которых лежит трикотажная одежда, джинсовая ткань и верхняя одежда с необычными принтами в рамках сезонной палитры цветов, символизируют современный гламур. Escada - это обязательные предметы одежды каждого трендсеттера и повседневные элементы гардероба, которые хороши как для выхода в свет, так и для появления в офисе.  Escada одежда предназначена для женщин с отличным чувством стиля, приверженностью к роскошному качеству и превосходному пошиву. Женщина Escada любит гламур, но понимает его по-новому и максимально современно.']
    },
    {
      title: 'Escada Сумки и Очки – Вырази Свою Индивидуальность',
      desc: ['В наше время Escada Group - это глобальная группа компаний в элитном сегменте, которая входит в число лидеров мирового рынка готовой женской одежды и моды в целом. Escada имеет 1100 торговых точек в более чем 80 странах мира. Корни компании уходят в 1976, а в ноябре 2009 года бывшая компания Escada AG была приобретена компанией Escada Luxembourg S.à r.l., которая косвенно принадлежит трасту семьи Миттал. В наше время вещи Escada можно приобрести и в онлайн магазинах, например, в нашем интернет бутике или, еще удобнее, загрузив наше модное приложение на любой девайс.  Обладая истинным пониманием того, чего хотят женщины сегодня, этот модный дом, производя Escada сумки, одежду и трендовые очки, фокусируется на безупречном пошиве и сочетании модных веяний с элементами в стиле 80-х. Эксклюзивная цветовая палитра подчеркивает сезонные тенденции и принты в каждой коллекции Escada. Трендовые очки Escada и Escada сумки обладают динамичным стилем и подчеркивают индивидуальность их обладательницы.']
    }
  ],
  'FENDI': [
    {
      title: 'Широкий Ассортимент Fendi Купить Онлайн в Приложении Posh Market',
      desc: ['Fendi – один из самых любимых в мире домов моды, который обожают за безупречно изготовленные кожаные изделия и гламурные коллекции одежды на все случаи жизни. В память о своей основательнице Адель Касагранде, которая создала в 1918 магазин кожи и меха в Риме на Виа дель Плебицио, дом продолжает исследовать красоту и элегантность в мире моды. Будь то культовый логотип F, разработанный Лагерфельдом, или линия изысканных аксессуаров, многолетнее наследие остается неотъемлемой частью бренда. Сегодня вещи марки Fendi купить онлайн можно быстро и удобно в приложении Posh Market']
    },
    {
      title: 'Почему Купить Сумку Fendi – Мечта Многих Модниц?',
      desc: ['Fendi – один из немногих семейных домов моды в Италии, прочно укоренившийся в мире трендов. Отличает одежду и аксессуары Фенди приверженность мастерству и творческому подходу. Обладая впечатляющим наследием, компания расширилась в 1970-х годах под творческим руководством Карла Лагерфельда, который закрепил фирменную нейтральную цветовую палитру бренда в течение своего пребывания на посту креативного директора. Что касается аксессуаров, то теперь лейбл сам по себе, а особенно культовые сумки Baguette и Peekaboo считаются культовой классикой нашего времени. Обе культовые модели были разработаны Сильвией Фенди,  единственным членом легендарного клана Фенди, который до сих пор работает в институте моды. Купить сумку Fendi теперь считают необходимостью для себя все модницы миры. Сильвия продолжает традиции семьи с артистическим подходом, который отражает историю Fendi, демонстрируя при этом в новых коллекциях инновационно обработанные ткани, дополняя их игривыми кожаными аксессуарами, такими как культовые меховые брелки Bag Bug, а также сумки и одежда с принтом глаз Monster.']
    }
  ],
  'GIANVITO ROSSI': [
    {
      title: 'Обувь Gianvito Rossi – Проявите Свой Итальянский Характер!',
      desc: ['Сделайте свои ножки шикарными, купив обувь Gianvito Rossi! Итальянская марка, которая производит обувь из различных материалов от гладкой замши до лакированной кожи, находится на модном Олимпе уже больше 10 лет и точно не собирается его покидать.Следуя по стопам своего отца – легендарного сапожника Серхио Росси, Джанвито Росси устанавливает идеальный баланс между современным дизайном и традиционным мастерством изготовления первоклассной обуви. С момента своего дебюта на Миланской неделе моды обувь Gianvito Rossi завоевала популярность среди редакторов модных изданий и икон стиля. Безупречный пошив и соблазнительные силуэты являются синонимами каждой коллекции бренда, а обувь Gianvito Rossi славится своим комфортом и износостойкостью. Росси также занят в реализации проекта «Сандалии из углеродного волокна»: таким образом роскошь, которой характеризуется обувь Gianvito Rossi, объединяется  с технологиями для создания легких сандалий с неповторимой ультрасовременной эстетикой.']
    },
    {
      title: 'Купить Gianvito Rossi Уже Сегодня',
      desc: ['На данный момент у марки есть собственная фабрика в Милане и бутики на Via Santo Spirito в Милане и на престижной Рю дю Мон Табор в Париже. Кроме того, купить Gianvito Rossi  можно уже сегодня – для этого не нужно покупать билеты в Париж или Милан, а можно просто загрузить наше приложение и получить доступ к покупке тех моделей, о которых вы всегда мечтали. Цветовые решения, графические принты и мелкие украшения делают обувь Gianvito Rossi неповторимым аксессуаром, который добавит особый завершающий штрих к вашему образу.']
    }
  ],
  'GIORGIO ARMANI': [
    {
      title: 'Giorgio Armani Купить Без Промедления',
      desc: ['Итальянский модный дом Giorgio Armani основан в 1975 году – а в 2001м креативный директор бренда был признан самым успешным дизайнером из Италии. Giorgio Armani – бренд, к которому мужчины и женщины обращаются за роскошной одеждой, обувью, кожаными изделиями и аксессуарами. Марка Giorgio Armani знаменита использованием изысканных тканей и простого кроя. Armani – это настоящий символ утонченной моды для всех и каждого. В онлайн-ассортименте нашего уникального приложения для мужчин и женщин вы найдете широкий выбор одежды Армани по несравненным ценам, от Emporio Armani до Armani Jeans. Армани - это бесспорная классика, и вы не ошибетесь, выбрав именно эту одежду и аксессуары для своего гардероба онлайн.']
    },
    {
      title: 'Одежда и Сумки Giorgio Armani - Настоящая Классика',
      desc: ['Видение Giorgio Armani – вневременной стиль и элегантность: эти  черты умело воплощаются в ассортименте бренда, в который входят одежда и сумки Giorgio Armani. Emporio Armani – это современная и истинно модная коллекция одежды и аксессуаров. Это стиль, который идет в ногу с модой и предвидит новые тенденции. Giorgio Armani купить – значит выбрать бренд, богатый идеями и нестандартными решениями для вашего гардероба.']
    }
  ],
  'GIUSEPPE ZANOTTI': [
    {
      title: 'Роскошная Обувь Giuseppe Zanotti',
      desc: ['Джузеппе Занотти родился в Сан-Мауро-Пасколи, адриатическом городе с давними традициями изготовления обуви. Более двадцати лет он работал над женской роскошной обувью, от дизайна и до изготовления, а затем зарекомендовал себя как дизайнер обуви для итальянских и международных компаний.  В 1994 году Джузеппе Занотти решил попробовать свои силы в собственном бизнесе. Затем последовал его путь как талантливого дизайнера неповторимой обуви, которое полностью оправдывает международное признание, которым бренд пользуется и в наше время. Первая коллекция обуви была представлена ​​через год. Бренд стал мощным представителем индустрии с более чем 300 сотрудниками, которые за короткое время производят около 450 тысяч пар обуви в год.']
    },
    {
      title: 'Где Купить Обувь Giuseppe Zanotti и Чем Она Знаменита?',
      desc: ['Джузеппе Занотти – дизайнер с утонченным вкусом и чувствительностью, человек, чье мировоззрение интернационально, а личность уникальна. Но Джузеппе Занотти - это не только творчество, но и мастерство кройки и пошива: «То, как изготавливается обувь, важно для ее успеха, но без навыков сапожника коллекция никогда не обретет идеальную форму».  Обувь Giuseppe Zanotti отличается гармоничным дизайном и изготовлена ​​из лучших материалов. Независимо от того, выбрали ли вы элегантные туфли на каблуках, сногсшибательные платформы или эффектно украшенные сандалии, обувь Giuseppe Zanotti никогда не оставит вас незамеченной. Что делает туфли, сандалии и ботинки Giuseppe Zanotti настолько уникальными, так это их непревзойденный синтез функциональности и качества дизайна. Глубокие знания в сфере дизайна и сапожного дела позволяют руководителям бренда идти в ногу с основными тенденциями, которые сезон за сезоном доминируют в мире модной одежды и обуви.']
    },
    {
      title: 'Купить Giuseppe Zanotti Москва',
      desc: 'Сегодня фирменные бутики можно найти практически в каждой столице мира. Giuseppe Zanotti Москва – это уникальное сочетание разных материалов, цветов и фактур в обуви высокого качества, которую теперь за пару кликов можно купить в нашем онлайн-бутике и приложении.'
    }
  ],
  'GIVENCHY': [
    {
      title: 'Givenchy Paris – Мрачный Романтизм Под Руку с Современностью',
      desc: ['Знаменитый модный дом Givenchy Paris, основанный в 1952 году легендарным Юбером де Живанши, известен первую очерендь своими кутюрными коллекциями. В настоящее время под творческим руководством Клэр Уайт Келлер марка придерживается своего исторического наследия и продолжает привлекать поклонников своей легкой готичностью и современным взглядом на женственность.  Комбинируя смелые архитектурные линии с романтичными мотивами, Givenchy в наше время стал популярен и среди трендсеттеров уличной моды . Givenchy Paris создает стильные коллекции, сочетающие мрачный романтизм и эстетику уличной одежды. Пройдя испытание временем, Givenchy приобрел целую армию знаменитых поклонников от неподражаемой Одри Хепберн до постмодернистской музы Кейт Бланшетт. Среди звездных ценителей марки  – Джей Зи, Рами Малек и даже принц Гарри.']
    },
    {
      title: 'Одежда, Обувь и Сумки Givenchy – Для Элегантных и Смелых',
      desc: ['Givenchy Paris твердо держит руку на пульсе того, что сейчас считается модным. Если вы тоже являетесь поклонницей романтизма с налетом готики, женственных элегантных силуэтов и изящных деталей в одежде и аксессуарах, добро пожаловать в наш онлайн-бутик: здесь вы найдете большой ассортимент вещей, обувь и сумки Givenchy на любой вкус!']
    }
  ],
  'GOLDEN GOOSE': [
    {
      title: 'Купить Golden Goose в Москве и Онлайн',
      desc: ['Основанный в 2000 году двумя молодыми креативными дизайнерами из Венеции, бренд Golden Goose без особых усилий объединяет американский вкус к моде с итальянским качеством. Менее чем за 10 лет  марка смогла завоевать себе заметное место на модном Олимпе. Беспрецедентное качество и неповторимое внимание к деталям наряду с фирменной аккуратной обработкой изделий стали основными характеристиками обуви и одежды Golden Goose.   Винтажные вещи с ориентальными мотивами – то самое, чем сразу же запоминаются кроссовки Golden Goose. Бренд полностью пересматривает подход к классической шнуровке, чтобы создать неповторимые кроссовки и кеды с низким и высоким верхом, которые подходят для любого гардероба. Каждая пара обязательно обладает фирменной отделкой GGDB и специфической «потертой» подошвой, которая придает интересный вид всем моделям Golden Goose. Коллекции Golden Goose сочетают традиционное итальянское мастерство с неожиданной для обуви чувственностью – супруги Алессандро Галло и Франческа Ринальдо, создавшие Golden Goose, черпают вдохновение в искусстве и в мотивах своего родного города Венеции. Сегодня вещи Golden Goose купить проще простого – загрузите наше приложение прямо сейчас и получите полный доступ к широкому выбору курток, платьев и обуви Golden Goose.']
    }
  ],
  'HERMES': [
    {
      title: 'Сумки Hermes Москва',
      desc: ['Сумки Hermes – самые желанные в мире, будь то Hermes Birkin, Hermes Kelly, Constance или Evelyne. Модный дом, созданный в 1837 году, регулярно выпускает дизайнерские коллекции сумок, которые воплощают определение роскоши – поэтому купить сумку Hermes Москва мечтает каждая настоящая модница. Дом Hermès был основан в 19 веке, а энтузиазм по поводу дизайна лейбла так же силен и сегодня. Знаменитые шелковые шарфы помогли распространить репутацию Hermès по всему миру, тем не менее изделия из кожи также занимают важное место в истории французского модного дома. Такие модели, как Kelly и Birkin, стали основой успеха Hermès и сыграли важную роль в демонстрации того, что бренд может предложить трендсеттерам со всего мира с точки зрения качества и ноу-хау.']
    },
    {
      title: 'Какую Сумку Hermes Купить?',
      desc: ['Эмиль-Морис Эрмес, внук основателя Тьерри Эрмеса, в 1920х определил философию бренда как «Кожа, спорт и традиция утонченной элегантности». Дом Hermès более 180 лет является синонимом качества дизайна и высокого уровня производства. В 21-го веке Hermès продолжает быть символом высокой французской роскоши.   История культовой сумки Birkin началась с того, что генеральный директор Hermès Жан-Луи Дюма встретился с певицей Джейн Биркин во время полета из Парижа в Лондон в 1981 году. Они обсудили идею о сумке, сочетающей в себе функциональность и элегантность. Аксессуар, приобревший легендарный статус, была создана с нуля в мастерской Эрмеса в 1984 году. В наше время все сумки Биркин тщательно изготавливаются вручную в разных размерах, материалах (от коровьей до страусиной кожи) и цветах. Подчеркивая округлость формы и эластичность кожи, сумка Hermes Kelly по-новому интерпретирует характерные детали классических сумочек. Hermes Москва cтавит во главу угла роскошь ручной работы и лучшие материалы, а вещи Hermès в наше время считаются настоящей классикой в ​​мире моды. Выберите сумки, клатчи и дорожные сумки Hermes идеального качества в нашем удобном приложении.']
    }
  ],
  'ICEBERG': [
    {
      title: 'Одежда Iceberg – Бунтарство с Комфортом',
      desc: ['Iceberg основан в 1974 году супругами Джерани, однако история бренда началась намного раньше. В 1962 году дизайнеры открыли фабрику трикотажа Gilmar, которая занималась производством трикотажа для мужчин. Позже ассортимент Iceberg расширялся все больше и больше, а особого шарма мужской коллекции придали красочные принты. Также в коллекциях Iceberg представлены спортивные брюки и оригинальные рубашки поло. Основанный командой Джерани, итальянский модный дом Iceberg в наше время специализируется на модной спортивной одежде с инновационными дизайнами, яркими цветами, изображениями произведений искусства и мультфильмов. Хотя Iceberg открыли свой первый бутик в Милане в 1989 году, а свой демонстрационный зал в Нью-Йорке в 1991 году,  возможность представить свою первую женскую коллекцию на подиумах Милана они получили только осенью 1995 года.']
    },
    {
      title: 'Iceberg Купить Уже Сегодня',
      desc: ['В конечном итоге Iceberg расширили свой ассортимент, включив в него детскую одежду, очки, часы, посуду и духи. Бренд представил свой первый парфюм Iceberg для женщин в 1989 году, а в 1991м выпустил первый одеколон для мужчин. Другим популярным в наше время ароматом от лейбла является современный, городской и спортивный Eau de Iceberg.    В коллекциях Iceberg красочная графика сочетается с итальянской роскошью: динамичный дом моды подвержен влиянию американского поп-арта, поэтому использует эти мотивы в коллекциях и сегодня, выпуская очень удобные вещи с бунтарским принтами. Придайте своему повседневному гардеробу свежесть и городскую роскошь, загрузив на любой девайс наше удобное приложение и получив доступ к широкому ассортименту модной одежды. Одежда Iceberg теперь доступна за пару кликов в вашем телефоне!']
    }
  ],
  'ISABEL MARANT': [
    {
      title: 'Isabel Marant Бренд из Парижа с Любовью',
      desc: ['Руководствуясь любовью к моде и стильной одежде, которая живет, развивается и меняется, парижский дизайнер Изабель Маран создает вещи для женщин, которые вполне подходят для повседневной носки. От обуви до ювелирных украшений и одежды, каждый элемент коллекций Isabel Marant имеет легкий богемный дух. Вещи бренда отличает расслабленный стиль с налетом роскоши, а широкий ассортимент включает в себя модные юбки, брюки, куртки и топы, которые легко вписываются в гардероб современных трендсеттеров. Коллекции, украшенные уникальными декоративными деталями, продолжают занимать первые строчки в вишлистах модниц со всего мира.   С момента запуска своей линии аксессуаров в 1989 году и линии женской одежды в 1994 году, Изабель Маран стала одним из самых выдающихся имен в индустрии моды. Роскошные кардиганы, идеальный крой каждого элемента и кеды на шнуровке стали основными отличительными чертами марки. Isabel Marant бренд является эстетическим воплощением парижского шика, а сама дизайнер утверждает, что вдохновляется на создание коллекций во всех уголках мира – от американского Запада до Французской Ривьеры. Дом моды Изабель Маран за последние годы получил статус культового и приобрел верных последователей стиля среди селебрити и модной элиты']
    },
    {
      title: 'Isabel Marant 2019 и 2020 – Что Нового Готовит Бренд?',
      desc: ['Изабель сама разрабатывает стиль бренда с момента создания своей первой линии трикотажных изделий Twen в 1989 году, а в 1995м она представила свой одноименный лейбл с более широким ассортиментом одежды. Несмотря на то, что каждый сезон Isabel Marant бренд предлагает свежие дизайны, он остается верным своей идентичности – французской роскоши и городскому шику. Коллекции Isabel Marant 2019 и 2020 известны своими богемными дизайнами. Откройте для себя самое лучшее из знаменитого Isabel Marant бренд в тщательно отобранном ассортименте нашего удобного приложения. Пару кликов – и вещи от Изабель Маран уже красуются в вашем гардеробе!']
    }
  ],
  'JIL SANDER': [
    {
      title: 'Jil Sander История Бренда',
      desc: ['Jil Sander история бренда свидетельствует, что сама Жиль Сандер открыла свой первый магазин в Гамбурге в 1967 году, когда ей было всего 24 года, но именно с популяризацией минимализма в 90-х ее чистые и сдержанные дизайны действительно оказались на пике модных тенденций. Сегодня лейбл продолжает демонстрировать ту же чистую эстетику, которая сделала его знаменитым. Jil Sander обувь и одежда в наше время - синоним чистых линий и точных деталей. Это модный дом, который славится своим дизайнерским мастерством и простотой моделей. Jil Sander история бренда гласит, что созданный в 1973 году как бренд с именем создателя, он приобрел максимальную популярность только через 2 десятилетия, благодаря фирменному минималистическому стилю. Под творческим руководством Родольфо Пальялунга, а потом во главе с Люси и Люком Майером, лейбл Джил Сандер бережет наследие модного лейбла, создавая коллекции платьев и стильных аксессуаров, изготовленных из лучших материалов с оттенком современной роскоши.']
    },
    {
      title: 'Jil Sander Обувь и Одежда - Простота и Шик',
      desc: ['Jil Sander история бренда началась с идеи “меньше и роскошнее” или проще говоря, минимализма, простоты и качества. Они и по сей день являются краеугольным камнем Jil Sander и подняли лейбл до уровня международного бренда, производящего вечную и чистую классику. Бывшие главные дизайнеры Raf Simons \'Dior и Supreme, соответственно, Люси и Люк Мейер взяли на себя бразды правления лейбла немецкого дизайнера Джил Сандер в 2017 году. Супружеский дуэт мужа и жены привносит освежающую душевность в коллекцию одежды бренда. Поэтому сегодня Jil Sander купить означает объединить в своем луке аскетичный минимализм с чувственностью и мягкостью.  Глубоко интуитивные дизайны бренда - это по своей сути безупречное равновесие между традицией и инновациями, мужским и женским, простотой и шиком. Инновационные материалы и исключительное мастерство как дизайнерского, так и производственного цеха, создают утонченную элегантность, которая заслужила международную известность Sander. Несмотря на некоторые финансовые и модные неудачи последнего десятилетия, бренд продолжает свое победоносное шествие модными подиумами и фэшн-бутиками мира с верой в совершенство и вниманием к деталям. В том числе, это эклектичное сочетание простоты и совершенства можно найти в нашем удобном приложении, просто загрузив его на любой удобный вам девайс.']
    }
  ],
  'JIMMY CHOO': [
    {
      title: 'Jimmy Choo Купить Уже Сегодня',
      desc: ['«Женщина Джимми Чу постоянно находится в движении, она легка и мимолетна, что и делает ее особенно привлекательной», – говорит креативный директор Сандра Чой. Это объясняет, почему купить Jimmy Choo считают для себя обязательным такие звезды, как Рианна и Кейт Миддлтон. Кроме того, Jimmy Choo сумки и туфли украшают бесчисленные красные дорожки и мировые подиумы. Jimmy Choo - это модный и удобный стиль для любого случая и вне времени и трендов. Бренд Джимми Чу стал синонимом гламурной женственной элегантности и прошел путь от скромных начинаний в Лондоне до мирового трендсеттера под творческим руководством Сандры Чой. Знаменитая обувь славится своими блестящими деталями, в том числе шипами, стразами и металлической отделкой. Выберите для себя сандалии Lance с несколькими ремешками, туфли с блестками и кроссовки Jimmy Choo, которые на удивление не менее гламурны, чем туфли на шпильке. Подберите Jimmy Choo сумки и клатчи ко всем своим нарядам буквально за пару кликов в нашем приложении.']
    },
    {
      title: 'Jimmy Choo Сумки и Обувь для Любой Модницы',
      desc: ['Обувь – это сердце и душа Джимми Чу. В начале 90-х годов Чу был обувным мастером в Ист-Энде Лондона, обожаемый не только лондонскими модницами, но и довольно известными клиентами, такими как Леди Ди.  В 1996 году Чу объединил усилия со своей племянницей Сандрой Чой, и вместе они создали фирму, которая превратилась в международный бренд обуви класса люкс, производящий туфли, босоножки, сандалии и кроссовки для любого случая. Являетесь ли вы приверженцем ультрасовременной уличной моды или предпочитаете классический стиль – вы гарантированно найдете идеальную пару обуви Jimmy Choo на свой вкус.']
    }
  ],
  'LANVIN': [
    {
      title: 'Lanvin Купить Уже Сегодня',
      desc: ['Дополните свой образ аксессуарами Lanvin или подберите к любому стильному луку Lanvin обувь! Эстетика бренда выражается в чистых линиях и гладких металлических украшениях в приглушенной, универсальной цветовой палитре. Lanvin, старейший в мире французский модный, существует с 1889 года. Основанный Жанной Ланвин как ателье на заказ на улице Фобур Сен-Оноре, этот дом моды в наше время сочетает парижскую элегантность и переосмысленную классику в одном флаконе.   Период развития бренда Lanvin под творческим руководством Лукаса Осендрейвера славится безупречным качеством и сильной, продуманной до мелочей эстетикой. Не пропустите легендарные кожаные аксессуары Lanvin, купить которые можно уже сегодня в нашем онлайн-магазине или удобном приложении.']
    },
    {
      title: 'Lanvin Обувь и Одежда 21 Века',
      desc: ['Бруно Сиалелли, который ранее работал с Джонатаном Андерсоном в Loewe, а также сотрудничал с Acne Studios, Пако Рабан и Баленсиага, был не так давно назначен креативным директором Lanvin. Он привнес в компанию новое ключевое направление, определяющее современное отношение бренда к моде. Кожаные сумки, трикотаж и хлопковые футболки украшены игривой графикой, а сапоги из телячьей кожи на шнуровке и балетки из кожи наппа источают парижскую элегантность. Эклектичные коллекции Сиалелли характеризуется многослойностью, мягкими формами, элегантным пошивом, яркими узорами и цветами. Стирая грани между мужской и женской одеждой, коллекции Сиалелли полностью меняют понимание стиля Lanvin.']
    }
  ],
  'LORO PIANA': [
    {
      title: 'Одежда и Обувь Loro Piana – Синоним Настоящей Роскоши',
      desc: ['Познакомьтесь с подлинной итальянской роскошью, которую вам может подарить одежда и обувь Loro Piana! Семейный бренд делает ставку на бескомпромиссное качество и производит превосходный текстиль и предметы роскоши, используя самое лучшее и редкое в мире сырье. С момента своего запуска Loro Piana является синонимом элегантности, инноваций и мастерства обработки кашемира и тонких тканей. Пьер Луиджи, возглавляющий сейчас культовый итальянский дом, продолжает традиции неизменно высокого качества Loro Piana и предлагает изделия, выдерживающие любое испытание временем. Стремление к совершенству стало миссией модного дома еще множество десятилетий тому назад, а ассортимент одежды и аксессуаров демонстрирует постоянную приверженность текстильным инновациям и при этом безусловную верность вечной итальянской элегантности.']
    },
    {
      title: 'Кашемировый Костюм Loro Piana – Мечта Всех Модниц!',
      desc: ['Основанный в 1924 году, бренд является крупнейшим в мире производителем кашемира и имеет долгую историю использования эксклюзивных тканей в своих дизайнах. Недавно открылся заповедник площадью 2000 гектаров, посвященный викунье – животному, чья шерсть снабжает бренд так называемым «волокном богов». Loro Piana пришла, чтобы установить эталон лучших нитей и тканей в мире, благодаря своим неустанным инвестициям в сырье и производство, а также постоянным техническим инновациям. Компания контролирует каждый этап производства в соответствии со своими строгими стандартами, от сбора натуральных волокон до доставки готовой продукции в свои магазины. Каждый Loro Piana интернет-магазин или оффлайн-бутик предложит вам широкое разнообразие безупречно сделанных детских кашемировых свитеров, шарфов с шелковыми вставками и замшевых туфель, ведь обувь Loro Piana – это качество, которого вы не найдете больше нигде в мире. Установите наше приложение прямо сейчас и получите полный доступ к моделям из натуральных тканей от Loro Piana!']
    }
  ],
  'MISSONI': [
    {
      title: 'Missoni Купить Одежду Инновационного Бренда',
      desc: ['Семейный бренд Missoni был основан в 1953 году в Варезе Оттавио и Розитой Миссони. Первоначально созданный как трикотажная мастерская, дом Missoni стал воплощать дух инноваций благодаря своим ярким геометрическим узорам, которые расширили само понимание дизайна. В 1998 году бренд перешел под контроль Анжелы Миссони, которая продолжила расширять линию трикотажа, развивая 25 направлений, включая купальники, мужскую одежду, аксессуары, парфюмерию и отели. Трикотажные ткани, динамичные узоры и смелая цветовая палитра – характерные черты бренда. Missoni купить означает вместе с одеждой получить новое ощущение радости жизни. Работая в индустрии моды более 20 лет, модный дом продолжает создавать удобные повседневные вещи, которые дополнят любой гардероб и подчеркнут стиль каждой модницы.']
    },
    {
      title: 'Missoni Платья, Обувь и Аксессуары с Узнаваемым Стилем',
      desc: ['Миссони была основана в 50-х годах и с тех пор продолжает оставаться прежде всего семейным делом. Анджела Миссони, которая уже два десятка лет стоит у руля бренда, постоянно обновляет образ Миссони. Коллекции Missoni обожают знаменитости и самые стильные женщины в мире. Зигзагообразный шарф или пончо Missoni может придать изюминку вашему наряду, а сногсшибательный галстук Missoni – стать акцентом стильного мужского лука. Обувь Missoni доступна в широком ассортименте стилей, способном удовлетворить все ваши модные потребности.']
    }
  ],
  'MAISON MARGIELA': [
    {
      title: 'Купить Maison Margiela Уже Сегодня',
      desc: ['Имя Мартина Марджелы давно ассоциируется с концептуальным дизайном и перспективным мышлением. Переезд в Париж определил судьбу бельгийского дизайнера, поскольку он оттачивал свое мастерство под руководством Джона Гальяно. Со своей первой коллекцией женской одежды Maison Margiela навсегда изменил понимание моды, поскольку модели ходили по подиуму в теперь уже всемирно известных ботинках Tabi, делая Maison Margiela все более культовым брендом с каждым шагом.  Радикальный концептуальный дизайнер Martin Margiela основал свой одноименный кутюрный дом в 1988 году и быстро утвердился в авангарде моды. В своем длительном отказе от интервью или появлений на публике он подчеркивал принципы анонимности и коллективного мастерства ателье. Трансформация и деконструкция всегда лежат в основе новой классической одежды бренда, а изысканные материалы, современные костюмы нестандартного кроя, минималистичные кожаные сумки, смарт украшения и бесконечные интерпретации фирменных кроссовок Replica являются основой коллекций модного дома.']
    },
    {
      title: 'Maison Margiela Обувь и Одежда для Экспериментаторов',
      desc: ['Парижский дом моды известен своим прогрессивным эстетическим и уникальным подходом к переосмыслению силуэтов мужской и женской одежды, а его коллекции включают в себя широкий ассортимент готовых предметов одежды, таких как футболки, свитера, толстовки и кожаные изделия. Купить Maison Margiela  можно уже сейчас в онлайн-бутике или нашем удобном приложении. Чего же вы ждете? Ведь одежда, обувь или сумка Maison Margiela может стать вашей уже сейчас!']
    }
  ],
  'MANOLO BLAHNIK': [
    {
      title: 'Туфли Manolo Blahnik Купить В Приложении Posh Market',
      desc: ['Когда дело доходит до обуви, Manolo Blahnik – первый бренд, который приходит на ум. Проложив путь к возвращению в моду утонченного женственного стиля, Маноло Бланик возродил очарование лодочек на шпильке в 1970-х годах, когда туфли на платформе были в авангарде моды. Сегодня туфли Manolo Blahnik купить становится мечтой и целью для множества городских модниц.']
    },
    {
      title: 'Лодочки Manolo Blahnik – От 70-х до «Секса в Большом Городе»',
      desc: ['Лодочки Manolo Blahnik известны во всем мире своими элегантными силуэтами и женственными расцветками – а сам Бланик по-прежнему занимает роль креативного директора и председателя. Модный традиционалист до сих пор делает наброски всех своих дизайнов обуви на бумаге, никогда не используя компьютер – так же, как при разработке концепции своего бренда в 1970 году. В конце 90-х на экраны вышел хит HBO Sex and The City, и благодаря обожествлению творений Бланика в сериале обувной гигант получил статус иконы поп-культуры. Отдавая пальму первенства классической обуви Manolo Blahnik как на экране, так и в повседневности, актриса Сара Джессика Паркер помогла моделям Hangisi и Mary-Jane Campy подняться на вершину славы. Приобретите свою любимую пару от Manolo Blahnik уже сегодня, ведь туфли Manolo Blahnik купить можно в несколько кликов, просто загрузив удобное приложение Posh Market!']
    }
  ],
  'MARC JACOBS': [
    {
      title: 'Marc Jacobs USA – Икона Современной Моды',
      desc: ['Marc Jacobs USA разжигает яркое пламя нью-йоркской моды своими яркими коллекциями. Аксессуары бренда – настоящий мастхэв для каждой модницы. Купить сумку Marc Jacobs USA , особенно цветную Snapshot со съемным ремешком – мечта огромного количества фэшиониста со всего света.    В Школе дизайна Parsons Марк Джейкобс считался настоящим вундеркиндом. С момента запуска именного бренда в 1986 году, дизайнер работает над созданием династии моды, которая продолжает приносить ему всё больше славы и популярности сезон за сезоном. Сегодня Marc Jacobs USA предлагает универсальные коллекции обуви в широком диапазоне размеров, цветов и стилей – обширная мужская линейка включает в себя ботинки, туфли и кроссовки для мужчин. Линия обуви Marc Jacobs для женщин – это кроссовки, сандалии, балетки, эспадрильи, туфли-лодочки, сабо и ботинки.']
    },
    {
      title: 'Купить Сумку Marc Jacobs и Обувь Marc Jacobs USA Уже Сегодня',
      desc: ['В разнообразных коллекциях Marc Jacobs USA вы гарантированно отыщете что-то по вкусу. В наше время купить сумку Marc Jacobs или обувь Marc Jacobs USA можно легко и без посещения бутиков в столице моды – обратите внимание на удобное приложение Posh Market с широким ассортиментом моделей от лучших мировых брендов.']
    }
  ],
  'MARNI': [
    {
      title: 'Бренд Marni – Итальянская Легенда',
      desc: ['Итальянский бренд Marni известен своим запоминающимся эклектичным дизайном: как утверждает креативный директор Marni бренда Франческо Риссо, каждая из его коллекций обладает особой индивидуальностью и характером.']
    },
    {
      title: 'Marni История Бренда',
      desc: ['Созданный в 1994 году Консуэло Кастильони, бренд Marni быстро прославился своей стильной одеждой и изысканными украшениями. С Франческо Риссо у руля, модный дом укрепил свое место в качестве фаворита модной индустрии благодаря своим неожиданным силуэтам, графичным цветовым решениям и контрастным текстурам.    В наше время бренд Marni разрабатывает одежду, обувь и аксессуары для мужчин и женщин, ориентируясь на фактуру, пропорции и цвет. Известный своим экспериментальным подходом к дизайну, Marni часто сотрудничает с художниками, чтобы создать диалог между мирами моды и искусства – такая кооперация обычно приводит к ярким и интересным результатам. Франческо Риссо и его команда поддерживают экспериментальный подход к материалам, принтам и формам и создают коллекции, любимые женщинами, чей стиль является творческим и самобытным.']
    },
    {
      title: 'Marni Купить В Москве и По Всему Миру',
      desc: ['Эстетика Marni основана на смелых принтах, скульптурных вырезах и художественных элементах, которые создали понятие creative chic. Сегодня уникальную одежду Marni купить в Москве или других городах можно с помощью нашего приложения буквально за несколько минут.']
    }
  ],
  'MIU MIU': [
    {
      title: 'Miu Miu Бренд Класса Люкс',
      desc: ['Miu Miu – бренд, основанный в 1993 году в рамках Prada Group, который сочетает в себе современную женственность, независимый образ мышления и экспериментальный характер модных решений. Миучча Прада была у руля бренда с самого его начала, а марка получила свое название благодаря прозвищу дизайнера. Miu Miu бренд предложил чувственный, бунтарский подход к одежде и стилю: сложные коллекции модного дома основаны на мужских, женских и исторических отсылках и мотивах. Не пропустите фирменные сумки Miu Miu Matelassé и культовую обувь Miu Miu в нашем удобном приложении. Загрузите и попробуйте его уже сейчас – пусть Miu Miu бренд станет ближе, ведь Miu Miu каталог в приложении Posh Market растет с каждым днем!']
    },
    {
      title: 'Miu Miu Каталог Бунтарской Одежды',
      desc: ['Одновременно скромные, чувственные и мятежные дизайны Miu Miu раскрывают многие, часто противоречивые, аспекты современной женственности. Фирменный стиль Miu Miu бренда включает обувь, украшенную хрусталем, вязаные свитера и украшенные драгоценными камнями воротники на рубашках, а также фирменные кожаные сумки, такие как Matelasse, Ultimate и Madras, в которых современный креативный директор бренда чтит наследие кожевников семьи Prada.']
    }
  ],
  'MONCLER': [
    {
      title: 'Moncler Купить Лыжную Одежду',
      desc: ['Moncler, названный в честь популярного горнолыжного курорта Monestier-de-Clermont во французских Альпах, является лидером в области зимней одежды. Основатель марки Réné Ramillion изначально производил палатки, спальные мешки и стеганые куртки, предназначенные для защиты работников от холода. Альпинист Лионель Террей обнаружил потенциал Moncler для защиты в суровых климатических условиях, и бренд превратился в лейбл спортивного снаряжения для лыжников и альпинистов. Облегченный пуховик, разработанный для французской команды по горнолыжному спорту на зимних Олимпийских играх 1968 года в Гренобле, стал предшественником фирменной модели Moncler.   Сегодня бренд использует знания экспертов по альпинизму для создания коллекций, которые объединяют функциональность с модой. А современные модницы, которые решают Moncler купить, в первую очередь обращают особое внимание на легкие утепленные пуховики и сапоги с подкладкой из овечьей шерсти.']
    },
    {
      title: 'Moncler Купить в Москве Или Онлайн',
      desc: ['В наше время Moncler продолжает выпускать мужские и женские стеганые пуховики, жилетки, парки, вязаные аксессуары и фирменные рубашки поло под руководством президента и креативного директора Ремо Руффини. Moncler купить в наше время можно по всему миру, в тому числе в бутиках Moncler Москва. Но удобнее всего это сделать онлайн в нашем интернет-бутике или загрузив удобное приложение и получив доступ к широкому ассортименту одежды и обуви Moncler.']
    }
  ],
  'PHILIPP PLEIN': [
    {
      title: 'Одежда и Обувь Philipp Plein – Выбор Дерзких',
      desc: ['С момента своего создания бренд Philipp Plein прошел долгий путь к своему индивидуальному, совершенно уникальному взгляду на современный гламур. В коллекциях бренда вы найдете платья в пол с драпировкой и сеткой, украшения с заклепками, узнаваемую обувь Philipp Plein, в том числе кожаные шпильки из змеиной кожи, а также фирменный принт с черепами. Стиль бренда Philipp Plein характеризуется спортивными мотивами и провокационным дизайном, а обувь Philipp Plein дополнит гламурный вечерний образ.   Одежду и обувь Philipp Plein купить в Москве теперь можно онлайн, быстро и по весьма привлекательным ценам. Загрузите наше приложение и получите доступ к неординарным и ярким вещам, воплощенным в коллекциях дизайнера Philipp Plein.']
    },
    {
      title: 'Одежда и Обувь Philipp Plein – Для Настоящих Бунтарок',
      desc: ['Женщина Philipp Plein  непреклонна – она ожидает и требует самого лучшего и отказывается идти на компромиссы. Преданность необычной красоте и страсть к рок-н-роллу – это те черты, которые вынудили Филиппа Плейна создать бренд, известный роскошью и революционным стилем.']
    }
  ],
  'RALPH LAUREN': [
    {
      title: 'Ralph Lauren Купить В Приложении Posh Market',
      desc: ['Ralph Lauren сочетает в себе проверенную временем эстетику стиля casual с английской изысканностью. Корпорация Ralph Lauren является мировым лидером в области дизайна, маркетинга и дистрибуции высококачественных товаров различных категорий: одежда, аксессуары, товары для дома, парфюмерия и т.д. На протяжении более 50 лет репутация и отличительный имидж Ральфа Лорена последовательно развивались в растущем числе продуктов, брендов и на международных рынках. Сегодня вдохновленные простотой Новой Англии, природной красотой Запада и гламурным Голливудом, коллекции Ральфа Лорена воплощают выражение стиля, неподвластного времени, признанного и прославленного во всем мире.']
    },
    {
      title: 'Ralph Lauren Москва',
      desc: ['На протяжении нескольких десятилетий Ральф Лорен предлагает своим покупателям не что иное, как безупречное качество. Одежду, обувь и аксессуары Ralph Lauren купить в Москве и по всей России теперь проще простого – установите удобное приложение Posh Market и получите доступ к сотням брендовых вещей со скидками до 90%!']
    }
  ],
  'SAINT LAURENT': [
    {
      title: 'Yves Saint Laurent Одежда- Легенда',
      desc: [
        'Элегантный, концептуальный и шикарный бренд Yves Saint Laurent был основан в 1961 году и является одним из самых легендарных имен в мире роскошной моды. Вначале YSL произвела революцию в индустрии моды, став первым брендом, выпустившим в 1966 году линию одежды Rive Gauche. Под творческим руководством Stefano Pilati с 2004 года дом Ив Сен-Лоран продолжает воплощать в жизнь утонченное современное понимание моды и инновационный французский стиль. Yves Saint Laurent одежда по праву считается легендой в мире моды.',
        'Парижский дом моды Yves Saint Laurent создал смокинг Le Smoking еще в 1966 году, и с тех пор они сохранили в своих мужских и женских коллекциях это безошибочное сочетание точного пошива и чувственности. Знаменитые мини-платья, каблуки на платформе, а также самые крутые байкерские куртки и блейзеры - все это входит в выбор Saint Laurent для женщин. Yves Saint Laurent одежда для женщина - это вершина вкуса.',
        'Передайте фирменный гламур бренда в своих аутфитах, купив одежду и обувь знааменитого французского бренда в нашем онлайн бутике или еще быстрее и удобнее, загрузив наше приложение с богатым ассортиментом модных эксклюзивных товаров. От вневременной байкерской куртки и расшитого блестками LBD до культовой сумки Kate - все эти вещи из разных коллекций отражает дух бренда Yves Saint Laurent.'
      ]
    },
    {
      title: 'Yves Saint Laurent Купить Уже Сегодня',
      desc: [
        'Ив Сен-Лоран основал один из самых знаменитых домов моды в 1961 году, перенеся концепцию роскоши в мир моды. Сегодня бренд Yves Saint Laurent продолжает вдохновлять трендсеттеров по всему миру под руководством креативного директора Энтони Ваккарелло.Бренд Yves Saint Laurent предпочитает сильный женский стиль, а значит Yves Saint Laurent купить хотела бы любая модница или просто стильная девушка. Французский лейбл частью мирового модного гламура, так как завораживающие силуэты Yves Saint Laurent производят шикарное впечатление на мировых подиумах сезон за сезоном. Энтони Ваккарелло в свое время отдает дань уважения блестящей истории бренда, сохранив при этом решительный взгляд в будущее.',
        'Yves Saint Laurent купить уже сегодня вы можете на нашем сайте или в приложении, загрузив его на удобный вам девайс.'
      ]
    }
  ],
  'SALVATORE FERRAGAMO': [
    {
      title: 'Salvatore Ferragamo Одежда и Обувь Для Поклонников Элегантного Стиля',
      desc: ['Уже почти сто лет Сальваторе Феррагамо является синонимом итальянского гламура. Основанная в 1924 году как голливудская обувная мастерская, компания Salvatore Ferragamo создавала обувь для селебрити – знаменитые клиенты Сальваторе Феррагамо, начиная от кинозвезд 1950-х годов и заканчивая европейскими королями, с самого начала были неотъемлемой частью бренда. Конечно, Salvatore Ferragamo обувь – это престижно, но сегодня коллекции бренда вышли далеко за пределы туфель и включают одежду, сумки и стильные аксессуары.']
    },
    {
      title: 'Salvatore Ferragamo Купить В Удобном  Приложении',
      desc: ['Сегодня одежду и обувь Salvatore Ferragamo купить совсем не сложно благодаря нашему маркетплейсу и удобному приложению. Загрузив приложение Posh Market, вы получите доступ к огромному ассортименту моделей из различных коллекций Salvatore Ferragamo высочайшего качества.']
    }
  ],
  'SEE BY CHLOE': [
    {
      title: 'See by Chloé Одежда и Обувь – Простота и Непринужденность',
      desc: ['See by Chloé демонстрирует непринужденный и простой подход к моде, но это ни в коем случае не означает, что у бренда отсутствует характерное парижское очарование. Каждая коллекция See by Chloé для женщин – это богемный дух, безупречный крой и пошив и выверенное сочетание простоты и элегантности. Бренд Chloé был основана в середине прошлого века Габи Агионом, но свобода, легкость и женственность Парижа 50-х остаются в основе дизайна бренда и сегодня. Возглавляемый креативным директором Наташей Рамсей-Леви, бренд остается верным корням своего легендарного родительского лейбла: пышные платья, блузки и сумки с кисточками воплощают в себе все, что нам нравится в непринужденном французском стиле.']
    },
    {
      title: 'See by Chloé Сумки и Обувь Под Любой Лук',
      desc: ['Развивайте чувство уверенности с обувью и аксессуарами See by Chloe. От дней, проведенных на улицах модных столиц до ночных вечеринок, вы можете рассчитывать на богемный и неподвластный времени дизайн See by Chloe, который привнесет в ваш образ ощущение приключения. See by Chloe обувь подходит как для солнечных дней, так и для непогоды, а сумки бренда представляют собой идеальное сочетание моды и функциональности. Пополните свой гардероб ботинками, сумками и свободными платьями See by Chloé уже сегодня, загрузив наше приложение за несколько кликов: See by Chloé одежда и обувь в широком ассортименте теперь доступна каждой моднице!']
    }
  ],
  'STELLA MCCARTNEY': [
    {
      title: 'Stella McCartney Stella Бренд Для Женщин',
      desc: ['Выпускница лондонского Central Saint Martins, Стелла Маккартни основала свой Stella McCartney бренд в 2001 году. Популярная селебрити , дочь известного музыканта и вегетарианка на протяжении всей жизни, она всегда отказывалась использовать кожу и мех в своих творениях, отдавая предпочтение экологичным материалам.   Что делает Stella McCartney одним из лидеров мировой модной индустрии? Бескомпромиссная позиция по использованию экологически чистых и переработанных материалов. Добавьте к этому точный аккуратный пошив, легкие ткани и своеобразную британскую причудливость, и вы получите бренд, который станет идеальным дополнением любого модного гардероба.']
    },
    {
      title: 'Stella McCartney Купить В Приложении Posh Market',
      desc: ['Сегодня коллекции Stella McCartney включают женскую одежду, аксессуары, нижнее белье, очки, парфюм. Бренд также может похвастаться многочисленными удачными коллаборациями.  Покупайте кроссовки, сумки и платья Stella McCartney в нашем удобном приложении и получите доступ к широкому ассортименту вещей этого бренда уже сейчас!']
    }
  ],
  'TOM-FORD': [
    {
      title: 'Tom Ford Купить Онлайн',
      desc: ['Том Форд запустил свой бренд в апреле 2005 года после работы на самые именитые модные дома. Фаворит среди знаменитостей и моделей с красной ковровой дорожки, а также создатель луков Дэниэла Крэйга в роли Джеймса Бонда, Том Форд прочно закрепил свой статус благодаря своему уникальному взгляду на современный дизайн. Tom Ford является синонимом сексуальной, неподвластной времени элегантности, превосходных материалов и качества изготовления, а также выдающегося клиентского сервиса.']
    },
    {
      title: 'Tom Ford Одежда С Вниманием К Деталям',
      desc: ['«Мужская одежда - это бизнес, основанный на деталях», – говорит Том Форд. Ознакомьтесь с ассортиментом мужской и женской одежды в приложении Posh Market и получите возможность Tom Ford купить онлайн в любое время суток всего за пару кликов!']
    }
  ],
  'VALENTINO': [
    {
      title: 'Valentino Бренд На Все Времена',
      desc: ['Valentino – бренд, зарекомендовавший себя как одна из современных легенд моды. Модный дом на протяжении десятилетий остается определением рафинированной женственности и гламура красных ковровых дорожек – ничего удивительного, ведь среди его поклонниц были такие дивы, как Элизабет Тейлор и Джеки Кеннеди!']
    },
    {
      title: 'Valentino Бренд В Наше Время',
      desc: ['С 2016 года креативным директором компании Пьерпаоло Пиччоли, который поддерживает фирменный стиль Валентино и одновременно придает ему более современный облик. Под пристальным взглядом Пиччоли роскошные платья, богатые принты и искусная вышивка снова стали важными чертами Валентино.  ']
    },
    {
      title: 'Валентино Купить Онлайн',
      desc: ['Valentino бренд представляет собой диалог между инновациями и традициями, являясь посредником между высокой модой и современной культурой. Обратите внимание на широкий ассортимент одежды, обуви, сумок и аксессуаров Valentino в нашем приложении!']
    }
  ],
  'VERSACE': [
    {
      title: 'Купить Платье Versace – Купить Мечту!',
      desc: ['Драматичная, сексуальная и запоминающаяся – так можно в нескольких словах охарактеризовать одежду бренда Versace. C тех пор, как в 1997 году компанию возглавила сестра Джанни Донателла Версаче, у бренда появились новые фирменные «фишки» – например, платья с вырезом, облегающие костюмы и высокие туфли на шпильках. Оставаясь верной яркой эстетике Джанни с принтами в стиле барокко, облегающими силуэтами и смелым брендингом, Донателла наполнила коллекции бренда соблазнительностью и дерзостью.']
    },
    {
      title: 'Versace Collection Интернет Магазин',
      desc: ['Все присущие Versace черты распространяются и на линию Versace Jeans Couture, которую, как и вещи основной линии, вы можете купить онлайн в нашем удобном приложении. От обуви, одежды и сумок до солнцезащитных очков, часов, ремней и нижнего белья – у бренда Versace есть все, что вы хотели бы получить от высокой моды.']
    }
  ],
  '3.1 PHILLIP LIM': [
    {
      title: 'Филлип Лим - Утонченная Элегантность',
      desc: [
        '“Уверенно, шикарно, а главное - без усилий”, - так Филлип Лим определяет эстетику своего бренда. Независимо от того, находитесь ли вы в поиске аксессуаров, стильной верхней одежды или легких платьев, каждая вещь, представляющая Phillip Lim бренд имеет “немного классический стиль, но придает ощущение индивидуальности”. It-girls стоит обратить особое внимание на современные аксессуары, которые производит марка Филлип Лим, такие как ультрамодное семейство сумок Pashli.',
        'Филлип Лим - американский модельер китайского происхождения, чьи родители эмигрировали в Америку из Таиланда во время геноцида в Камбодже. Лим был одним из основателей лейбла Fashion и сотрудничал с компанией с 2000 по 2004 год.',
        'Филлип Лим выпустил свою одноименную коллекцию в 2005 году, назвав ее 3.1 в честь своего 31-летия. Дизайнер из Нью-Йорка считает свой город своей музой. Его “фишкой” по праву называются утонченные, но доступные дизайны. Юбки и платья, бомберы, большие вязаные вещи, разноцветные меха и короткая шерсть, а также фирменные сумки, сочетающие в себе причудливую женственность и утонченную уличную элегантность. Неординарные рисунки и цветовые решения привносят нотку романтичности и эмоциональности в одежду Phillip Lim бренда. Женская одежда Phillip Lim всегда интересна и отличается юношеской элегантностью и индивидуальным стилем.'
      ]
    },
    {
      title: 'Phillip Lim Бренд - Фукциональность и Оригинальность',
      desc: [
        'Привычные цвета с налетом эксцентричности - это понимание стиля, с которым китайско-американский дизайнер Phillip Lim запустил свой бренд и которого продолжает придерживаться эта марка. Шикарные ткани, оригинальные принты и вычурные детали делают классические вещи, такие как брюки и платья, намного интересней. Каждая коллекция идеально сочетает в себе оригинальность и функциональность.',
        'В 2007 году Совет дизайнеров одежды Америки наградил Лима премией как новый талант в сфере женской моды. В 2012 году он получил награду Swarovski, а в 2013 - звание «Дизайнер аксессуаров года».',
        'В наше время дизайнер Филлип Лим, известный своим немного небрежным подходом к крою, продолжает сочетать в своих коллекциях точность и непринужденность. В результате получаются знаменитые футболки Phillip Lim бренда, нашумевшие спортивные брюки для бега и стильные аксессуары, в том числе знаменитая сумка Pashli. Обратите внимание на ассортимент вещей и аксессуаров Phillip Lim, представленных в нашем онлайн бутике!'
      ]
    }
  ],
  'CHRISTIAN LOUBOUTIN': [
    {
      title: 'Christian Louboutin – Туфли Мечты',
      desc: ['Коллекции Кристиана Лабутена – это идеальное сочетание французского  гламура и итальянского мастерства. Лучше всего суть этого бренда выражает история фирменных подошв, которые все еще имеют все туфли Christian Louboutin. Дизайнер, работая в своей студии в 90-х годах, взял бутылку красного лака для ногтей у своей помощницы Сары и раскрасил подошву обуви.  С момента запуска в 1991 году роскошные туфли Christian Louboutin стали легко узнаваемы благодаря уникальной ярко-красной лакированной подошве каждой пары. От элегантных So Kate и до узнаваемого стиля Pigalle - каждая коллекция этой обуви становится по-настоящему культовой. Покупайте желанные туфли Christian Louboutin на шпильке с красной подошвой в нашем онлайн бутике или с помощью приложения, загрузить которое можно буквально за пару минут. Всё от высоких каблуков и до шикарных туфель на плоской подошве – модницы, предпочитающие Christian Louboutin Москва несомненно найдут свою идеальную пару, соответствующую их стилю. Стремитесь к большему? Тогда предлагаем вам обратить внимание на неповторимый дизайн сумок лейбла, созданный с тем же итальянским качеством, которым известны туфли Christian Louboutin.']
    },
    {
      title: 'Christian Louboutin Москва – Изящество и Комфорт',
      desc: ['Первые туфли Christian Louboutin были изготовлены в Италии опытными мастерами. В наше время изысканная обувь на каблуке, кроссовки и балетки бренда являются синонимами комфорта и изящества.  Обратите внимание на классические дизайны So Kate и Pigalle, представленные в нашей коллекции Christian Louboutin Москва. Они придадут блеск и модные изюминку любому образу. Не забудьте также выбрать стильные сумки к вашим лукам – например, сумочки с заклепками можно буквально с помощью пары кликов купить в нашем приложении уже сегодня.']
    }
  ],
  'ETRO': [
    {
      title: 'Etro Интернет Магазин Эклектичной Моды',
      desc: ['Миланский дом моды Etro и любой современный представляющий бренд Etro интернет магазин известен своей эклектичной смесью калейдоскопических принтов, великолепных цветов и дорогих тканей. Изначально бренд был основан в 1968 году как текстильный дом, производящий принтованные ткани высочайшего качества, в том числе культовый пейсли-мотив Etro. Стиль Etro в значительной степени вдохновлен семидесятыми, эстетикой хиппи с легкими воротниками, прозрачными блузами и плавными линиями платьев того времени. Все эти элементы до сих пор являются фаворитами марки. Сегодня марка Etro приобрела всемирную известность благодаря своему красочному текстилю, аксессуарам, ароматам и одежде. Неповторимый стиль бренда сочетает широкий ассортимент смелых цветов и принтов с классическим пошивом, наполняя каждый образ эклектичной богемной эстетикой.']
    },
    {
      title: 'Etro Обувь, Одежда и Аксессуары с Многолетней Историей',
      desc: ['Творческий, экспериментальный и дальновидный бренд из Милана может похвастаться многолетней историей инноваций и успеха. Уже более сорока лет бренд Etro является синонимом итальянского стиля, элегантности и качества. Сын основателя, Кин Этро, в свое время разрабатывал коллекции мужской одежды, которые сочетают в себе безупречное мастерство с искусным использованием принтов и модных цветов. За прошедшие десятилетия лейбл Etro получил признание благодаря своим классическим силуэтам – платьям для женщин, рубашкам для мужчин, а также кожаным аксессуарам в ярких оттенках с неповторимыми графическими узорами. С момента своего запуска семейный бренд зарекомендовал себя как дом моды для смелых и при этом роскошных образов. Не пропустите широкий выбор различных моделей из коллекций Etro Москва в нашем онлайн магазине или загрузите наше удобное приложение, чтобы буквально за несколько кликов иметь возможность купить вещи лейбла с пейсли-принтами, а также украшения и шикарную обувь Etro.']
    }
  ],
  'MAX MARA': [
    {
      title: 'Max Mara Italy - Воплощение Итальянского Стиля',
      desc: ['Основанный в городе Реджо-Эмилия Ахиллом Марамотти, Max Mara Italy представляет собой воплощение итальянского качества и мастерства. Модный бренд обожают за его пальто и современный, утонченный подход к классике, который выходит за пределы сезона и тенденций. Когда дело доходит до смешения традиционного ремесленного подхода с промышленным производством, Макс Мара считается одним из основателей повседневной моды такой, какой мы знаем ее сегодня. За годы деятельности бренд привлекал к коллаборации самых известных дизайнеров мира, в том числе Карла Лагерфельда, Доменико Дольче и Стефано Габбана, но тем не менее и по сей день остается семейным бизнесом. В коллекциях Max Mara Italy часто встречается табачный, темно-синий, кремовый и насыщенный красный цвет, который источает элегантность и грацию. Под руководством Лоры Лусарди Max Mara Italy в наше время остается одним из любимых брендов модниц, предпочитающих классические цвета и силуэты, эффектную отделку, а также стильные сумки и сдержанные аксессуары.']
    },
    {
      title: 'Max Mara Купить Онлайн Прямо Сейчас',
      desc: ['Предназначенный для женщин, которые ценят утонченную роскошь и наследие итальянского мастерства, Max Mara Italy создает сложные силуэты в нейтральной цветовой палитре.  С момента основания бренд продолжает совершенствоваться и заново изобретать свою минималистичную и современную эстетику, которую называют культом пошива. Max Mara купить сегодня можно в фирменных оффлайн-бутиках, а также в онлайн-магазинах. Решили купить одежду бренда Max Mara Italy? Загрузите наше удобное приложение и начинайте выбирать!']
    }
  ],
  'CELINE': [
    {
      title: 'Сумка Celine как Символ Моды',
      desc: ['Оставаясь верным своей концепции, Celine создает современные, чистые и элегантные изделия вне времени из качественных материалов, которые прослужат максимально долго. В каждой новой коллекции французский модный дом играет на контрастах: женственное против мужественного, драматическая линия плеч и узкая талия, четкие силуэты брюк и плавные подолы. На первый взгляд одежда бренда может показаться минималистичной и базовой, но если вы решитесь купить Celine, то при более пристальном рассмотрении сможете заметить, что у каждого предмета есть особенные уникальные элементы. Внимание к деталям и удобство – это то, чем бренд так гордится, и к чему стремятся его поклонницы. Бренд отстаивает концепцию функционального, простого и стильного гардероба – не зря ведь каждая сумка Celine становится настоящей it-сумкой! Купить Celine уже сегодня вы можете благодаря нашему онлайн-бутику: просто выберите понравившуюся вам модель, и долгожданная сумка Celine станет вашей за пару кликов!']
    }
  ],
  'PAUL SMITH': [
    {
      title: 'Paul Smith Купить Прямо Сейчас',
      desc: ['Пол Смит – британский модельер, который искусно соединяет традиции с современностью. Он родился в Ноттингеме и мечтал стать профессиональным велосипедистом, но из-за полученной в аварии травме не смог продолжать свою спортивную карьеру. В конце концов Пол открыл свой собственный магазин и начал заниматься пошивом одежды: клиенты полюбили его творения, и Paul Smith купить стало для многих настоящей мечтой.    Знаменитый своими коллекциями одежды и аксессуаров, бренд специализируется на изобретательском мастерстве и ультрасовременном дизайне, так что в наше время Paul Smith купить обязан каждый уважающий себя фэшиониста.  Лидер британской моды, бренд Paul Smith уделяет особое внимание уникальным принтам и цветовым комбинациям. Вещи Paul Smith, купить которые мечтают многие, отличаются качеством и аутентичностью – коллекции бренда демонстрирует мастерство дизайнера, безупречную конструкцию и особое видение деталей.']
    },
    {
      title: 'Paul Smith Москва и Весь Мир',
      desc: ['За последние двадцать пять лет Пол Смит прочно зарекомендовал себя как новатор в мире моды. Обувь, одежда, солнцезащитные очки и купальники Paul Smith имеют узнаваемый дизайн с особым вниманием к деталям. Коллекции бренда производятся в Англии и Италии, а используемые ткани в основном итальянского, французского и британского происхождения. Paul Smith купить же в наше время можно в различных бутиках, в том числе Paul Smith Москва, а также в нашем удобном приложении, загрузить которое можно за несколько кликов.']
    }
  ],
  'BRUNELLO CUCINELLI': [
    {
      title: 'Купить Brunello Cucinelli Удобно и Быстро',
      desc: ['Brunello Cucinelli – бренд, базирующийся в итальянском регионе Умбрия и известный своими роскошными кашемировыми вещами, создает классическую готовую одежду для мужчин и женщин. Особенно в коллекциях стоит выделить элегантные платья, костюмы и обувь Brunello Cucinelli, а также кошельки и сумки. Купить Brunello Cucinelli – настоящая мечта для многих модников, ведь за многие десятилетия он ведущим в мире брендом класса люкс по производству кашемира. Цель бренда - привнести роскошный и изысканный стиль в жизнь тех, кто его выбирает.']
    },
    {
      title: 'Одежда и Обувь Brunello Cucinelli – Настоящая Итальянская Роскошь!',
      desc: ['Бренд, основанный в 1978 году, по-прежнему управляется представителями семьи, а тщательно продуманная обувь Brunello Cucinelli, одежда и аксессуары для стильных женщин и мужчин привлекает к себе внимание международного модного сообщества. Сегодня сложно представить ценителя качественной одежды, который не хотел бы купить Brunello Cucinelli для своей коллекции. И если раньше купить одежду и обувь Brunello Cucinelli можно было только в оффлайн-бутиках, то теперь это можно легко сделать буквально за пару кликов прямо на этой странице!']
    }
  ]
}

export const CATEGORY_SEO_TEXT = {
  'premium': [
    {
      title: 'Брендовая Одежда Для Женщин',
      desc: ['Покупайте лучшие мировые бренды и формируйте свой гардероб из дизайнерской одежды для женщин, широкий выбор которой доступен на нашем сайте Posh Market и в удобном приложении. В нашем ассортименте брендовая одежда для женщин, в том числе выдающиеся модели от Сен-Лорана, Валентино и Хлои. Если вы любите делать покупки творений начинающих дизайнеров-экспериментаторов, смело заявляющих о себе в мире моды, то вы находитесь в правильном месте. Вниманию наших покупательниц с чудесным вкусом  широкий выбор дизайнерских платьев, брюк идеального покроя и базовых рубашек. Если вы не знаете, с чего начать покупки дизайнерской одежды для женщин, просто обратите внимание на громкие имена на нашем сайте.   Posh Market - это самый надежный источник для поиска дизайнерской и роскошной женской одежды. Наша команда Posh Market ставит перед собой основную цель -  привнести лучшие тренды мировой моды в гардеробы фашионистас и избавить от необходимости покупать некачественные реплики вместо покупки оригинала. Благодаря свежим новинкам с подиумов и коллекций лучших брендов на нашем удобном сайте и в мобильном приложении вы быстро и легко получите опыт уникального трендового шоппинга.'],
      point: false
    },
    {
      title: 'Неповторимый Шоппинг - Брендовая Одежда Для Женщин',
      desc: [
        'Широкий ассортимент более 100 международных брендов класса люкс',
        'Новинки каждую неделю',
        'Удобный выбор и быстрая покупка в онлайн магазине',
        'Эксклюзивная брендовая одежда для женщин, которую вы не найдете больше нигде'
      ],
      point: true
    },
    {
      title: 'Posh Market - Лучшие Трендовые Вещи Со Всего Мира',
      desc: [
        'Только оригиналы - аутентичность гарантирована',
        'Быстрая и надежная доставка',
        'Прекрасное обслуживание клиентов и дружелюбный персонал'
      ],
      point: true
    }
  ],
  'bags': [
    {
      title: 'Брендовые Сумки Женские от Posh Market',
      desc: ['Женские дизайнерские сумки прошли долгий и интересный путь в мире моды, чтобы стать самым главным аксессуаром и самой желанной частью коллекций модниц. От роскошных кожаных кошельков с ослепительной металлической фурнитурой до элегантных современных клатчей, украшенных прекрасными узорами, шипами и блестками - в приложении Posh Market есть брендовые сумки женские на любой вкус.   Независимо от того, о какой дизайнерской сумочке вы мечтаете, вы обязательно найдете ту, в которую влюбитесь. Posh Market предлагает вам сумки от всемирно известных модных лейблов.']
    },
    {
      title: 'Самые Шикарные Модные Сумки',
      desc: ['Очаровательные, эксклюзивные и широко обсуждаемые брендовые сумки женские - это то, что вы можете с легкостью найти и приобрести в приложении Posh Market. Сумки, характеризующиеся оригинальным дизайном, высочайшим мастерством дизайна и истинной роскошью, являются в наше время не только основным элементом гардероба, но и смелым заявлением о стиле.   Знаменитые бренды, такие как Gucci и Saint Laurent, часто покоряют поклонниц моды, благодаря классическим наплечным сумкам, клатчам, рюкзакам, вечерним сумкам и шопперам, украшенным логотипами и монограммами. А американские кутюрье-экспериментаторы, такие как Том Форд и Марк Джейкобс, создают уникальное имя для себя и своих изысканных коллекций, тем самым привлекая внимание самых прогрессивных фашионистас и модных трендсеттеров.   Знаменитые дизайнерские клатчи, представленные в приложении Posh Market, такие как Fendi Baguette и Givenchy Antigona, имеют звездный статус, благодаря своим запоминающимся дизайнам, выдающемуся качеству и привлекательности. Разве вам не хотелось бы иметь в своем гардеробе брендовые сумки женские, которые носят Кейт Мосс, Сара Джессика Паркер и Кара Делевинь?']
    },
    {
      title: 'Эксклюзивные Брендовые Сумки Женские от Posh Market',
      desc: ['Позвольте себе купить дизайнерскую сумочку с классической и неподвластной времени эстетикой или отдайте предпочтение экспериментальному и революционному современному клатчу. Широкий ассортимент женских сумок от Posh Market включает в себя брендовые сумки женские, изготовленные из самых роскошных и прочных тканей - блестящей кожи, мягкой замши, роскошного меха и бархата. Королевские объемные сумки, дизайнерские сумочки через плечо, блестящие клатчи и стильные шопперы от Posh Market заставят всех говорить о вашем вкусе и стиле.']
    }
  ],
  'sneackers': [
    {
      title: 'Брендовая Обувь Для Женщин',
      desc: ['Ваша новая пара роскошной обуви буквально в нескольких кликах от вас - в нашем удобном приложении Posh Market. У нас вы найдете широкий ассортимент мастерски изготовленных балеток, элегантной обуви на каблуке и даже ботильонов и сапог от международных модных брендов. Если брендовая обувь для женщин - ваша мечта и вы ищите парижский шик или изысканную итальянскую роскошь в новой паре туфелек, обратите внимание на невероятный выбор в приложении Posh Market.']
    },
    {
      title: 'Что Такое Брендовая Обувь Для Женщин?',
      desc: ['Дизайнерская брендовая обувь для женщин является предметом споров, слухов и сплетен в мире моды, а также основой международных новостных заголовков. Знаменитые туфли и женщины, которые их носили, привлекают внимание на протяжении всей истории - от Одри Хепберн в повседневных балетках до Кэрри Брэдшоу в ярких и сверкающих лодочках на высоком каблуке. А неповторимое разнообразие дизайнерских туфель в телевизионном сериале “Секс в большом городе” вызвало в свое время бурную реакцию среди стильных девушек всего мира.']
    },
    {
      title: 'Модная Обувь Для Повседневности',
      desc: ['Выберите самую элегантную обувь или ультрамодные модели в быстром приложении Posh Market. Брендовая обувь для женщин, разработанная известными домами мод, поистине привлекательна и эксклюзивна.   Кроссовки, ботильоны, каблуки и лоферы от дизайнеров роскошной обуви, таких как Givenchy, Balenciaga и Stella McCartney, изготовлены из роскошных тканей, включая замшу, мех и кожу. Надевайте пары обуви от Posh Market каждый день как часть делового костюма или гламурного наряда.']
    },
    {
      title: 'Брендовая Обувь Для Женщин от Posh Market',
      desc: ['Дизайнерские туфли, предлагаемые в Posh Market и предназначенные для всех случаев жизни, находятся буквально в паре кликов от вас и доступны в приложении. Кожаные лоферы Fendi и сандалии Tom Ford придают непринужденную роскошную атмосферу любому образу, в то время как классические вещи Dolce & Gabbana или жаккардовые босоножки, легко вписываются в луки для вечеринок.   Роскошная и оригинальная брендовая обувь для женщин находится всего в нескольких кликах от. Попробуйте наше эксклюзивное приложение Posh Market с неповторимым ассортиментом, удобным поиском и уникально быстрой доставкой.']
    }
  ],
  'heels': [
    {
      title: 'Брендовая Обувь Для Женщин',
      desc: ['Ваша новая пара роскошной обуви буквально в нескольких кликах от вас - в нашем удобном приложении Posh Market. У нас вы найдете широкий ассортимент мастерски изготовленных балеток, элегантной обуви на каблуке и даже ботильонов и сапог от международных модных брендов. Если брендовая обувь для женщин - ваша мечта и вы ищите парижский шик или изысканную итальянскую роскошь в новой паре туфелек, обратите внимание на невероятный выбор в приложении Posh Market.']
    },
    {
      title: 'Что Такое Брендовая Обувь Для Женщин?',
      desc: ['Дизайнерская брендовая обувь для женщин является предметом споров, слухов и сплетен в мире моды, а также основой международных новостных заголовков. Знаменитые туфли и женщины, которые их носили, привлекают внимание на протяжении всей истории - от Одри Хепберн в повседневных балетках до Кэрри Брэдшоу в ярких и сверкающих лодочках на высоком каблуке. А неповторимое разнообразие дизайнерских туфель в телевизионном сериале “Секс в большом городе” вызвало в свое время бурную реакцию среди стильных девушек всего мира.']
    },
    {
      title: 'Модная Обувь Для Повседневности',
      desc: ['Выберите самую элегантную обувь или ультрамодные модели в быстром приложении Posh Market. Брендовая обувь для женщин, разработанная известными домами мод, поистине привлекательна и эксклюзивна.   Кроссовки, ботильоны, каблуки и лоферы от дизайнеров роскошной обуви, таких как Givenchy, Balenciaga и Stella McCartney, изготовлены из роскошных тканей, включая замшу, мех и кожу. Надевайте пары обуви от Posh Market каждый день как часть делового костюма или гламурного наряда.']
    },
    {
      title: 'Брендовая Обувь Для Женщин от Posh Market',
      desc: ['Дизайнерские туфли, предлагаемые в Posh Market и предназначенные для всех случаев жизни, находятся буквально в паре кликов от вас и доступны в приложении. Кожаные лоферы Fendi и сандалии Tom Ford придают непринужденную роскошную атмосферу любому образу, в то время как классические вещи Dolce & Gabbana или жаккардовые босоножки, легко вписываются в луки для вечеринок.   Роскошная и оригинальная брендовая обувь для женщин находится всего в нескольких кликах от. Попробуйте наше эксклюзивное приложение Posh Market с неповторимым ассортиментом, удобным поиском и уникально быстрой доставкой.']
    }
  ]
}
